/******/(()=>{// webpackBootstrap
/******/"use strict";
/******/ // The require scope
/******/var t={};
/******/
/************************************************************************/
/******/ /* webpack/runtime/global */
/******/
/******/t.g=function(){
/******/if("object"==typeof globalThis)return globalThis;
/******/try{
/******/return this||new Function("return this")();
/******/}catch(t){
/******/if("object"==typeof window)return window;
/******/}
/******/}();
/**
 * @type Settings
 */
var e={scale:1,template:!1,templateRender:// CONCATENATED MODULE: ./node_modules/@pixelunion/rimg-shopify/dist/index.es.js
/*!
 * @pixelunion/rimg-shopify v2.7.1
 * (c) 2023 Pixel Union
 */
/*!
 * @pixelunion/rimg v2.2.2
 * (c) 2022 Pixel Union
 */
/**
 * The default template render function. Turns a template string into an image
 * URL.
 *
 * @param {String} template
 * @param {Size} size
 * @returns {String}
 */
function defaultTemplateRender(t,e){return t.replace("{size}","".concat(e.width,"x").concat(e.height))},max:{width:Infinity,height:Infinity},round:32,placeholder:!1,crop:null};
/**
 * Get a data attribute value from an element, with a default fallback and
 * sanitization step.
 *
 * @param {Element} el
 *
 * @param {String} name
 *        The data attribute name.
 *
 * @param {Object} options
 *        An object holding fallback values if the data attribute does not
 *        exist. If this object doesn't have the property, we further fallback
 *        to our defaults.
 *
 * @param {Function} [sanitize]
 *        A function to sanitize the data attribute value with.
 *
 * @returns {String|*}
 */function getData(t,i,n,r){var o="data-rimg-".concat(i);if(!t.hasAttribute(o))return n[i]||e[i];var s=t.getAttribute(o);return r?r(s):s}
/**
 * Sanitize data attributes that represent a size (in the form of `10x10`).
 *
 * @param {String} value
 * @returns {Object} An object with `width` and `height` properties.
 */function parseSize(t){return t=t.split("x"),{width:parseInt(t[0],10),height:parseInt(t[1],10)}}
/**
 * Sanitize crop values to ensure they are valid, or null
 *
 * @param {String} value
 * @returns {Object} Shopify crop parameter ('top', 'center', 'bottom', 'left', 'right') or null, if an unsupported value is found
 */function processCropValue(t){switch(t){case"top":case"center":case"bottom":case"left":case"right":return t;default:return null}}
/**
 * Loads information about an element.
 *
 * Options can be set on the element itself using data attributes, or through
 * the `options` parameter. Data attributes take priority.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 * @returns {Item}
 */function parseItem(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.hasAttribute("data-rimg-template");
/**
   * @typedef {Settings} Item
   */
return{el:t,
// Type of element
isImage:n,isBackgroundImage:n&&"IMG"!==t.tagName,
// Image scale
scale:parseInt(getData(t,"scale",i)),
// Device density
density:window.devicePixelRatio||1,
// Image template URL
template:getData(t,"template",i),templateRender:i.templateRender||e.templateRender,
// Maximum image dimensions
max:getData(t,"max",i,parseSize),
// Round image dimensions to the nearest multiple
round:getData(t,"round",i),
// Placeholder image dimensions
placeholder:getData(t,"placeholder",i,parseSize),
// Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
crop:getData(t,"crop",i,processCropValue)}}
/**
 * Round to the nearest multiple.
 *
 * This is so we don't tax the image server too much.
 *
 * @param {Number} size The size, in pixels.
 * @param {Number} [multiple] The multiple to round to the nearest.
 * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
 * @returns {Number}
 */function roundSize(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:32,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Infinity;return 0===t?e:Math.min(Math.ceil(t/e)*e,i)}
/**
 * Get the size of an element.
 *
 * If it is too small, it's parent element is checked, and so on. This helps
 * avoid the situation where an element doesn't have a size yet or is positioned
 * out of the layout.
 *
 * @param {HTMLElement} el
 * @return {Object} size
 * @return {Number} size.width The width, in pixels.
 * @return {Number} size.height The height, in pixels.
 */
/**
 * Trigger a custom event.
 *
 * Note: this approach is deprecated, but still required to support older
 * browsers such as IE 10.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 *
 * @param {HTMLElement} el
 *        The element to trigger the event on.
 *
 * @param {String} name
 *        The event name.
 *
 * @returns {Boolean}
 *          True if the event was canceled.
 */
function trigger(t,e){var i=document.createEvent("Event");return i.initEvent(e,!0,!0),!t.dispatchEvent(i)}
/**
 * Set the image URL on the element. Supports background images and `srcset`.
 *
 * @param {Item} item
 * @param {Size} size
 * @param {Boolean} isPlaceholder
 */function setImage(t,e,i,n){var r,o=t.templateRender,s=i?1:
/**
 * Return the maximum supported density of the image, given the container.
 *
 * @param {Item} item
 * @param {Size} size
 */
function supportedDensity(t,e){return Math.min(Math.min(Math.max(t.max.width/e.width,1),t.density),Math.min(Math.max(t.max.height/e.height,1),t.density)).toFixed(2)}(t,e),a=i?1:t.round,l=e.width*s,c=e.height*s;if(t.crop)r={width:roundSize(l,a,t.max.width),height:roundSize(c,a,t.max.height)};else{
// Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
// To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
// This isn't a problem with cropped images which are served at the exact dimension requested.
var d=e.width/e.height,h=t.max.width/t.max.height;
// fit width
r=d>h?{width:roundSize(l,a,t.max.width),height:roundSize(l/h,a,t.max.height)}:{width:roundSize(c*h,a,t.max.width),height:roundSize(c,a,t.max.height)}}var u=o(t.template,r),p=new Image;// On load callback
p.onload=n,p.src=u,// Set image
t.isBackgroundImage?t.el.style.backgroundImage="url('".concat(u,"')"):t.el.setAttribute("srcset","".concat(u," ").concat(s,"x"))}
/**
 * Load the image, set loaded status, and trigger the load event.
 *
 * @fires rimg:load
 * @fires rimg:error
 * @param {Item} item
 * @param {Size} size
 */function loadFullImage(t,e){var i=t.el;setImage(t,e,!1,(function(t){"load"===t.type?i.setAttribute("data-rimg","loaded"):(i.setAttribute("data-rimg","error"),trigger(i,"rimg:error")),trigger(i,"rimg:load")}))}
/**
 * Load in a responsive image.
 *
 * Sets the image's `srcset` attribute to the final image URLs, calculated based
 * on the actual size the image is being shown at.
 *
 * @fires rimg:loading
 *        The image URLs have been set and we are waiting for them to load.
 *
 * @fires rimg:loaded
 *        The final image has loaded.
 *
 * @fires rimg:error
 *        The final image failed loading.
 *
 * @param {Item} item
 */function loadImage(t){var e=t.el,i=e.getAttribute("data-rimg");// Already loaded?
if("loading"!==i&&"loaded"!==i)// Is the SVG loaded?
// In Firefox, el.complete always returns true [citation needed, may not be the case anymore, Jan/2022]
// so we also check el.naturalWidth, which equals 0 until the image loads
if(t.isBackgroundImage||0!==e.naturalWidth&&e.complete){// Trigger loading event, and stop if cancelled
if(!trigger(e,"rimg:loading")){// Mark as loading
e.setAttribute("data-rimg","loading");// Get element size. This is used as the ideal display size.
var n=function getElementSize(t){for(var e={width:0,height:0};t&&(e.width=t.offsetWidth,e.height=t.offsetHeight,!(e.width>20&&e.height>20));)t=t.parentNode;return e}(t.el);n.width*=t.scale,n.height*=t.scale,t.placeholder?(
// Load a placeholder image first, followed by the full image. Force the
// element to keep its dimensions while it loads. If the image is smaller
// than the element size, use the image's size. Density is taken into account
// for HiDPI devices to avoid blurry images.
t.isBackgroundImage||(e.setAttribute("width",Math.min(Math.floor(t.max.width/t.density),n.width)),e.setAttribute("height",Math.min(Math.floor(t.max.height/t.density),n.height))),setImage(t,t.placeholder,!0,(function(){return loadFullImage(t,n)}))):loadFullImage(t,n)}}else
// Wait for the load event, then call load image
e.addEventListener("load",(function cb(){e.removeEventListener("load",cb),loadImage(t)}))}
/**
 * Prepare an element to be displayed on the screen.
 *
 * Images have special logic applied to them to swap out the different sources.
 *
 * @fires rimg:enter
 *        The element is entering the viewport.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 */function load(t,e){if(t){trigger(t,"rimg:enter");var i=parseItem(t,e);i.isImage&&(i.isBackgroundImage||t.setAttribute("data-rimg-template-svg",t.getAttribute("srcset")),loadImage(i))}}
/**
 * Reset an element's state so that its image can be recalculated.
 *
 * @fires rimg:update
 *        The element is being updated.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 */function update(t,e){if(t){trigger(t,"rimg:update");var i=parseItem(t,e);i.isImage&&(i.isBackgroundImage||(t.setAttribute("data-rimg","lazy"),t.setAttribute("srcset",t.getAttribute("data-rimg-template-svg"))),loadImage(i))}}
/**
 * Returns true if the element is within the viewport.
 * @param {HTMLElement} el
 * @returns {Boolean}
 */function inViewport(t){if(!t.offsetWidth||!t.offsetHeight||!t.getClientRects().length)return!1;var e=document.documentElement,i=Math.min(e.clientWidth,window.innerWidth),n=Math.min(e.clientHeight,window.innerHeight),r=t.getBoundingClientRect();return r.bottom>=0&&r.right>=0&&r.top<=n&&r.left<=i}
/**
 * @typedef {Object} Size
 * @property {Number} width
 * @property {Number} height
 */
/**
 * A function to turn a template string into a URL.
 *
 * @callback TemplateRenderer
 * @param {String} template
 * @param {Size} size
 * @returns {String}
 */
/**
 * @typedef {Object} Settings
 *
 * @property {String} [template]
 *           A template string used to generate URLs for an image. This allows us to
 *           dynamically load images with sizes to match the container's size.
 *
 * @property {TemplateRenderer} [templateRender]
 *           A function to turn a template string into a URL.
 *
 * @property {Size} [max]
 *           The maximum available size for the image. This ensures we don't
 *           try to load an image larger than is possible.
 * 
 * @property {Number} [scale]
 *           A number to scale the final image dimensions by. 
 *           Only applies to lazy-loaded images. Defaults to 1.
 *
 * @property {Number} [round]
 *           Round image dimensions to the nearest multiple. This is intended to
 *           tax the image server less by lowering the number of possible image
 *           sizes requested.
 *
 * @property {Size} [placeholder]
 *           The size of the lo-fi image to load before the full image.
 * 
 * @property {String} [crop]
 *           Crop value; null if image is uncropped, otherwise equal 
 *           to the Shopify crop parameter ('center', 'top', etc.).
 */
/**
 * Initialize the responsive image handler.
 *
 * @param {String|HTMLElement|NodeList} selector
 *        The CSS selector, element, or elements to track for lazy-loading.
 *
 * @param {Settings} options
 *
 * @returns {PublicApi}
 */function rimg(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:'[data-rimg="lazy"]',e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=new IntersectionObserver((function(t){t.forEach((function(t){(t.isIntersecting||t.intersectionRatio>0)&&(i.unobserve(t.target),load(t.target,e))}))}),{
// Watch the viewport, with 20% vertical margins
rootMargin:"20% 0px"}),n={
/**
     * Track a new selector, element, or nodelist for lazy-loading.
     * @type Function
     * @param {String|HTMLElement|NodeList} selector
     */
track:function track(){for(var t=querySelector(arguments.length>0&&void 0!==arguments[0]?arguments[0]:'[data-rimg="lazy"]'),n=0;n<t.length;n++)
// If an element is already in the viewport, load it right away. This
// fixes a race-condition with dynamically added elements.
inViewport(t[n])?load(t[n],e):i.observe(t[n])},
/**
     * Update element(s) that have already been loaded to force their images
     * to be recalculated.
     * @type Function
     * @param {String|HTMLElement|NodeList} selector
     */
update:function update$1(){for(var t=querySelector(arguments.length>0&&void 0!==arguments[0]?arguments[0]:'[data-rimg="loaded"]'),i=0;i<t.length;i++)update(t[i],e)},
/**
     * Stop tracking element(s) for lazy-loading.
     * @type Function
     * @param {String|HTMLElement|NodeList} selector
     */
untrack:function untrack(){for(var t=querySelector(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"[data-rimg]"),e=0;e<t.length;e++)i.unobserve(t[e])},
/**
     * Manually load images.
     * @type Function
     * @param {String|HTMLElement|NodeList} selector
     */
load:function load$1(){for(var t=querySelector(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"[data-rimg]"),i=0;i<t.length;i++)load(t[i],e)},
/**
     * Unload all event handlers and observers.
     * @type Function
     */
unload:function unload(){i.disconnect()}};// Add initial elements
return n.track(t),n}
/**
 * Finds a group of elements on the page.
 *
 * @param {String|HTMLElement|NodeList} selector
 * @returns {Object} An array-like object.
 */function querySelector(t){return"string"==typeof t?document.querySelectorAll(t):t instanceof HTMLElement?[t]:t instanceof NodeList?t:[]}
/**
 * Polyfill for Element.matches().
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.mozMatchesSelector||Element.prototype.msMatchesSelector||Element.prototype.oMatchesSelector||Element.prototype.webkitMatchesSelector||function(t){for(var e=(this.document||this.ownerDocument).querySelectorAll(t),i=e.length;--i>=0&&e.item(i)!==this;);return i>-1});var i={init:function init(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:'[data-rimg="lazy"]',e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};// Support custom events triggered through jQuery
// See: https://github.com/jquery/jquery/issues/3347
i.selector=t,i.instance=rimg(t,e),i.loadedWidth=Math.max(document.documentElement.clientWidth,window.innerWidth||0),// Listen for Shopify theme editor events
document.addEventListener("shopify:section:load",(function(t){return watch(t.target)})),window.addEventListener("resize",(function(){
/**
 * Update an element, and its children.
 *
 * @param {HTMLElement} el
 */
return function _update(){var t=Math.max(document.documentElement.clientWidth,window.innerWidth||0);// Return if we're not 2x smaller, or larger than the existing loading size
if(t/i.loadedWidth>.5&&t/i.loadedWidth<2)return;i.loadedWidth=t,i.instance.update()}
/* harmony default export */()})),document.addEventListener("shopify:section:unload",(function(t){return unwatch(t.target)})),// Listen for custom events to allow themes to hook into rimg
document.addEventListener("theme:rimg:watch",(function(t){return watch(t.target)})),document.addEventListener("theme:rimg:unwatch",(function(t){return unwatch(t.target)})),window.jQuery&&jQuery(document).on({"theme:rimg:watch":function themeRimgWatch(t){return watch(t.target)},"theme:rimg:unwatch":function themeRimgUnwatch(t){return unwatch(t.target)}})}
/**
 * Track an element, and its children.
 *
 * @param {HTMLElement} el
 */,watch:watch,unwatch:unwatch,load:
/**
 * Manually load an image
 *
 * @param {HTMLElement} el
 */
function load$1(t){
// Load element
"function"==typeof t.matches&&t.matches(i.selector)&&i.instance.load(t);// Load element's children
i.instance.load(t.querySelectorAll(i.selector))}};function watch(t){
// Track element
"function"==typeof t.matches&&t.matches(i.selector)&&i.instance.track(t),// Track element's children
i.instance.track(t.querySelectorAll(i.selector))}
/**
 * Untrack an element, and its children
 *
 * @param {HTMLElement} el
 * @private
 */function unwatch(t){
// Untrack element's children
i.instance.untrack(t.querySelectorAll(i.selector)),// Untrack element
"function"==typeof t.matches&&t.matches(i.selector)&&i.instance.untrack(t)}const n=i;// CONCATENATED MODULE: ./node_modules/@pixelunion/pxs-complementary-products/dist/index.es.js
/*!
 * @pixelunion/pxs-complementary-products v3.5.3
 * (c) 2022 Pixel Union
 */
function _typeof(t){return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},_typeof(t)}function _defineProperties(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var r="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:void 0!==t.g?t.g:"undefined"!=typeof self?self:{};function createCommonjsModule(t,e){return t(e={exports:{}},e.exports),e.exports}var o=createCommonjsModule((function(t,e){e.__esModule=!0;var i=/** @class */function(){function EventHandler(){this.events=[]}return EventHandler.prototype.register=function(t,e,i){return t&&e&&i?(this.events.push({el:t,event:e,listener:i}),t.addEventListener(e,i),{el:t,event:e,listener:i}):null},EventHandler.prototype.unregister=function(t){var e=t.el,i=t.event,n=t.listener;return e&&i&&n?(this.events=this.events.filter((function(t){return e!==t.el||i!==t.event||n!==t.listener})),e.removeEventListener(i,n),{el:e,event:i,listener:n}):null},EventHandler.prototype.unregisterAll=function(){this.events.forEach((function(t){var e=t.el,i=t.event,n=t.listener;return e.removeEventListener(i,n)})),this.events=[]},EventHandler}();e.default=i})),s=function unwrapExports(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}(o);function _defineProperties$1(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function _defineProperty(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function ownKeys(t,e){var i=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),i.push.apply(i,n)}return i}function _slicedToArray(t,e){return function _arrayWithHoles(t){if(Array.isArray(t))return t}(t)||function _iterableToArrayLimit(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var i=[],n=!0,r=!1,o=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done)&&(i.push(s.value),!e||i.length!==e);n=!0);}catch(t){r=!0,o=t}finally{try{n||null==a.return||a.return()}finally{if(r)throw o}}return i}(t,e)||function _unsupportedIterableToArray(t,e){if(!t)return;if("string"==typeof t)return _arrayLikeToArray(t,e);var i=Object.prototype.toString.call(t).slice(8,-1);"Object"===i&&t.constructor&&(i=t.constructor.name);if("Map"===i||"Set"===i)return Array.from(i);if("Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))return _arrayLikeToArray(t,e)}(t,e)||function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function _arrayLikeToArray(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n}var a={},l=function(){function AsyncView(){!
/*!
   * @pixelunion/shopify-asyncview v2.0.5
   * (c) 2020 Pixel Union
  */
function _classCallCheck$1(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,AsyncView)}return function _createClass$1(t,e,i){return e&&_defineProperties$1(t.prototype,e),i&&_defineProperties$1(t,i),t}(AsyncView,null,[{key:"load",
/**
     * Load the template given by the provided URL into the provided
     * view
     *
     * @param {string} url - The url to load
     * @param {object} query - An object containing additional query parameters of the URL
     * @param {string} query.view - A required query parameter indicating which view to load
     * @param {object} [options] - Config options
     * @param {string} [options.hash] - A hash of the current page content
     */
value:function load(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!("view"in e))return Promise.reject(new Error("'view' not found in 'query' parameter"));var n=t.replace(/\?[^#]+/,""),r=new RegExp(/.+\?([^#]+)/).exec(t),o=e;r&&r.length>=2&&r[1].split("&").forEach((function(t){var e=_slicedToArray(t.split("="),2),i=e[0],n=e[1];o[i]=n}));// NOTE: We're adding an additional timestamp to the query.
// This is to prevent certain browsers from returning cached
// versions of the url we are requesting.
// See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
var s=function _objectSpread2(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{};e%2?ownKeys(Object(i),!0).forEach((function(e){_defineProperty(t,e,i[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):ownKeys(Object(i)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e))}))}return t}({},o,{_:(new Date).getTime()}),l=n.replace(/([^#]+)(.*)/,(function(t,e,i){return"".concat(e,"?").concat(Object.keys(o).sort().map((function(t){return"".concat(t,"=").concat(encodeURIComponent(o[t]))})).join("&")).concat(i)})),c=n.replace(/([^#]+)(.*)/,(function(t,e,i){return"".concat(e,"?").concat(Object.keys(s).sort().map((function(t){return"".concat(t,"=").concat(encodeURIComponent(s[t]))})).join("&")).concat(i)})),d=new Promise((function(t,e){var n;if(l in a)t(a[l]);else{if(a[l]=d,i.hash&&(n=sessionStorage.getItem(l))){var r=JSON.parse(n);if(i.hash===r.options.hash)return delete a[l],void t(r)}var o=new XMLHttpRequest;o.open("GET",c,!0),o.onload=function(){var e=o.response,n={},r=e.querySelector("[data-options]");r&&r.innerHTML&&(n=JSON.parse(e.querySelector("[data-options]").innerHTML));var s=e.querySelectorAll("[data-html]"),c={};if(1===s.length&&""===s[0].getAttribute("data-html"))c=s[0].innerHTML;else for(var d=0;d<s.length;d++)c[s[d].getAttribute("data-html")]=s[d].innerHTML;var h=e.querySelectorAll("[data-data]"),u={};if(1===h.length&&""===h[0].getAttribute("data-data"))u=JSON.parse(h[0].innerHTML);else for(var p=0;p<h.length;p++)u[h[p].getAttribute("data-data")]=JSON.parse(h[p].innerHTML);if(i.hash)try{sessionStorage.setItem(l,JSON.stringify({options:n,data:u,html:c}))}catch(t){console.error(t)}delete a[l],t({data:u,html:c})},o.onerror=function(){delete a[l],e()},o.responseType="document",o.send()}}));return d}}]),AsyncView}(),c=createCommonjsModule((function(t){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */
/* jshint unused: true, undef: true, strict: true */var e,i;e="undefined"!=typeof window?window:r,i=function(){function EvEmitter(){}var t=EvEmitter.prototype;return t.on=function(t,e){if(t&&e){
// set events hash
var i=this._events=this._events||{},n=i[t]=i[t]||[];
// set listeners array
// only add once
return-1==n.indexOf(e)&&n.push(e),this}},t.once=function(t,e){if(t&&e){
// add event
this.on(t,e);
// set once flag
// set onceEvents hash
var i=this._onceEvents=this._onceEvents||{};
// set onceListeners object
// set flag
return(i[t]=i[t]||{})[e]=!0,this}},t.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},t.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){
// copy over to avoid interference if .off() in listener
i=i.slice(0),e=e||[];for(
// once stuff
var n=this._onceEvents&&this._onceEvents[t],r=0;r<i.length;r++){var o=i[r];n&&n[o]&&(
// remove listener
// remove before trigger to prevent recursion
this.off(t,o),
// unset once flag
delete n[o]),
// trigger listener
o.apply(this,e)}return this}},t.allOff=function(){delete this._events,delete this._onceEvents},EvEmitter},
// universal module definition
/* jshint strict: false */ /* globals define, module, window */
t.exports?
// CommonJS - Browserify, Webpack
t.exports=i():
// Browser globals
e.EvEmitter=i()})),d=createCommonjsModule((function(t){
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */
/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */
!function(e,i){
/* jshint strict: false */ /* globals define, module */
t.exports?
// CommonJS
t.exports=i():
// browser global
e.getSize=i()}(window,(function factory(){
// -------------------------- helpers -------------------------- //
// get a number from a string, not a percentage
function getStyleSize(t){var e=parseFloat(t);
// not a percent like '100%', and a number
return-1==t.indexOf("%")&&!isNaN(e)&&e}var t="undefined"==typeof console?function noop(){}:function(t){console.error(t)},e=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],i=e.length;
// -------------------------- measurements -------------------------- //
// -------------------------- getStyle -------------------------- //
/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle(e){var i=getComputedStyle(e);return i||t("Style returned "+i+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),i}
// -------------------------- setup -------------------------- //
var n,r=!1;
// -------------------------- getSize -------------------------- //
function getSize(t){
// do not proceed on non-objects
if(
/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup(){
// setup once
if(!r){r=!0;
// -------------------------- box sizing -------------------------- //
/**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
var t=document.createElement("div");t.style.width="200px",t.style.padding="1px 2px 3px 4px",t.style.borderStyle="solid",t.style.borderWidth="1px 2px 3px 4px",t.style.boxSizing="border-box";var e=document.body||document.documentElement;e.appendChild(t);var i=getStyle(t);
// round value for browser zoom. desandro/masonry#928
n=200==Math.round(getStyleSize(i.width)),getSize.isBoxSizeOuter=n,e.removeChild(t)}}(),
// use querySeletor if elem is string
"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var o=getStyle(t);
// if hidden, everything is 0
if("none"==o.display)return function getZeroSize(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},n=0;n<i;n++)t[e[n]]=0;return t}();var s={};s.width=t.offsetWidth,s.height=t.offsetHeight;
// get all measurements
for(var a=s.isBorderBox="border-box"==o.boxSizing,l=0;l<i;l++){var c=e[l],d=o[c],h=parseFloat(d);
// any 'auto', 'medium' value will be 0
s[c]=isNaN(h)?0:h}var u=s.paddingLeft+s.paddingRight,p=s.paddingTop+s.paddingBottom,f=s.marginLeft+s.marginRight,g=s.marginTop+s.marginBottom,m=s.borderLeftWidth+s.borderRightWidth,y=s.borderTopWidth+s.borderBottomWidth,v=a&&n,w=getStyleSize(o.width);!1!==w&&(s.width=w+(
// add padding and border unless it's already including it
v?0:u+m));var b=getStyleSize(o.height);return!1!==b&&(s.height=b+(
// add padding and border unless it's already including it
v?0:p+y)),s.innerWidth=s.width-(u+m),s.innerHeight=s.height-(p+y),s.outerWidth=s.width+f,s.outerHeight=s.height+g,s}}return getSize}))})),h=createCommonjsModule((function(t){
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */
/*jshint browser: true, strict: true, undef: true, unused: true */
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i():
// browser global
e.matchesSelector=i()}(window,(function factory(){var t=function(){var t=window.Element.prototype;
// check for the standard method name first
if(t.matches)return"matches";
// check un-prefixed
if(t.matchesSelector)return"matchesSelector";
// check vendor prefixes
for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i]+"MatchesSelector";if(t[n])return n}}();return function matchesSelector(e,i){return e[t](i)}}))})),u=createCommonjsModule((function(t){
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */
/*jshint browser: true, undef: true, unused: true, strict: true */
!function(e,i){
// universal module definition
/*jshint strict: false */ /*globals define, module, require */
t.exports?
// CommonJS
t.exports=i(e,h):
// browser global
e.fizzyUIUtils=i(e,e.matchesSelector)}(window,(function factory(t,e){var i={
// ----- extend ----- //
// extends objects
extend:function(t,e){for(var i in e)t[i]=e[i];return t},
// ----- modulo ----- //
modulo:function(t,e){return(t%e+e)%e}},n=Array.prototype.slice;
// turn element or nodeList into an array
i.makeArray=function(t){return Array.isArray(t)?t:
// return empty array if undefined or null. #6
null==t?[]:"object"==typeof t&&"number"==typeof t.length?n.call(t):[t]},
// ----- removeFrom ----- //
i.removeFrom=function(t,e){var i=t.indexOf(e);-1!=i&&t.splice(i,1)},
// ----- getParent ----- //
i.getParent=function(t,i){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,i))return t},
// ----- getQueryElement ----- //
// use element as selector string
i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},
// ----- handleEvent ----- //
// enable .ontype to trigger from .addEventListener( elem, 'type' )
i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},
// ----- filterFindElements ----- //
i.filterFindElements=function(t,n){
// make array of elems
t=i.makeArray(t);var r=[];return t.forEach((function(t){
// check that elem is an actual element
if(t instanceof HTMLElement)
// add elem if no selector
if(n){
// filter & find items if we have a selector
// filter
e(t,n)&&r.push(t);
// find children
// concat childElems to filterFound array
for(var i=t.querySelectorAll(n),o=0;o<i.length;o++)r.push(i[o])}else r.push(t)})),r},
// ----- debounceMethod ----- //
i.debounceMethod=function(t,e,i){i=i||100;
// original method
var n=t.prototype[e],r=e+"Timeout";t.prototype[e]=function(){var t=this[r];clearTimeout(t);var e=arguments,o=this;this[r]=setTimeout((function(){n.apply(o,e),delete o[r]}),i)}},
// ----- docReady ----- //
i.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?
// do async to allow for other scripts to run. metafizzy/flickity#441
setTimeout(t):document.addEventListener("DOMContentLoaded",t)},
// ----- htmlInit ----- //
// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,(function(t,e,i){return e+"-"+i})).toLowerCase()};var r=t.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
// -----  ----- //
return i.htmlInit=function(e,n){i.docReady((function(){var o=i.toDashed(n),s="data-"+o,a=document.querySelectorAll("["+s+"]"),l=document.querySelectorAll(".js-"+o),c=i.makeArray(a).concat(i.makeArray(l)),d=s+"-options",h=t.jQuery;c.forEach((function(t){var i,o=t.getAttribute(s)||t.getAttribute(d);try{i=o&&JSON.parse(o)}catch(e){
// log error, do not initialize
return void(r&&r.error("Error parsing "+s+" on "+t.className+": "+e))}
// initialize
var a=new e(t,i);
// make available via $().data('namespace')
h&&h.data(t,n,a)}))}))},i}))})),p=createCommonjsModule((function(t){
// Flickity.Cell
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(e,d):(
// browser global
e.Flickity=e.Flickity||{},e.Flickity.Cell=i(e,e.getSize))}(window,(function factory(t,e){function Cell(t,e){this.element=t,this.parent=e,this.create()}var i=Cell.prototype;return i.create=function(){this.element.style.position="absolute",this.element.setAttribute("aria-hidden","true"),this.x=0,this.shift=0,this.element.style[this.parent.originSide]=0},i.destroy=function(){
// reset style
this.unselect(),this.element.style.position="";var t=this.parent.originSide;this.element.style[t]="",this.element.style.transform="",this.element.removeAttribute("aria-hidden")},i.getSize=function(){this.size=e(this.element)},i.setPosition=function(t){this.x=t,this.updateTarget(),this.renderPosition(t)},
// setDefaultTarget v1 method, backwards compatibility, remove in v3
i.updateTarget=i.setDefaultTarget=function(){var t="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[t]+this.size.width*this.parent.cellAlign},i.renderPosition=function(t){
// render position of cell with in slider
var e="left"===this.parent.originSide?1:-1,i=this.parent.options.percentPosition?t*e*(this.parent.size.innerWidth/this.size.width):t*e;this.element.style.transform="translateX("+this.parent.getPositionValue(i)+")"},i.select=function(){this.element.classList.add("is-selected"),this.element.removeAttribute("aria-hidden")},i.unselect=function(){this.element.classList.remove("is-selected"),this.element.setAttribute("aria-hidden","true")},
/**
 * @param {Integer} shift - 0, 1, or -1
 */
i.wrapShift=function(t){this.shift=t,this.renderPosition(this.x+this.parent.slideableWidth*t)},i.remove=function(){this.element.parentNode.removeChild(this.element)},Cell}))})),f=createCommonjsModule((function(t){
// slide
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i():(
// browser global
e.Flickity=e.Flickity||{},e.Flickity.Slide=i())}(window,(function factory(){function Slide(t){this.parent=t,this.isOriginLeft="left"==t.originSide,this.cells=[],this.outerWidth=0,this.height=0}var t=Slide.prototype;return t.addCell=function(t){
// first cell stuff
if(this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1==this.cells.length){this.x=t.x;// x comes from first cell
var e=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=t.size[e]}},t.updateTarget=function(){var t=this.isOriginLeft?"marginRight":"marginLeft",e=this.getLastCell(),i=e?e.size[t]:0,n=this.outerWidth-(this.firstMargin+i);this.target=this.x+this.firstMargin+n*this.parent.cellAlign},t.getLastCell=function(){return this.cells[this.cells.length-1]},t.select=function(){this.cells.forEach((function(t){t.select()}))},t.unselect=function(){this.cells.forEach((function(t){t.unselect()}))},t.getCellElements=function(){return this.cells.map((function(t){return t.element}))},Slide}))})),g=createCommonjsModule((function(t){
// animate
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(e,u):(
// browser global
e.Flickity=e.Flickity||{},e.Flickity.animatePrototype=i(e,e.fizzyUIUtils))}(window,(function factory(t,e){
// -------------------------- animate -------------------------- //
var i={startAnimation:function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},animate:function(){this.applyDragForce(),this.applySelectedAttraction();var t=this.x;
// animate next frame
if(this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating){var e=this;requestAnimationFrame((function animateFrame(){e.animate()}))}},positionSlider:function(){var t=this.x;
// wrap position around
this.options.wrapAround&&this.cells.length>1&&(t=e.modulo(t,this.slideableWidth),t-=this.slideableWidth,this.shiftWrapCells(t)),this.setTranslateX(t,this.isAnimating),this.dispatchScrollEvent()},setTranslateX:function(t,e){t+=this.cursorPosition,
// reverse if right-to-left and using transform
t=this.options.rightToLeft?-t:t;var i=this.getPositionValue(t);
// use 3D transforms for hardware acceleration on iOS
// but use 2D when settled, for better font-rendering
this.slider.style.transform=e?"translate3d("+i+",0,0)":"translateX("+i+")"},dispatchScrollEvent:function(){var t=this.slides[0];if(t){var e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent("scroll",null,[i,e])}},positionSliderAtSelected:function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,// stop wobble
this.positionSlider())},getPositionValue:function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},settle:function(t){!this.isPointerDown&&Math.round(100*this.x)==Math.round(100*t)&&this.restingFrames++,
// stop animating if resting for 3 or more frames
this.restingFrames>2&&(this.isAnimating=!1,delete this.isFreeScrolling,
// render position with translateX when settled
this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},shiftWrapCells:function(t){
// shift before cells
var e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);
// shift after cells
var i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},_shiftCells:function(t,e,i){for(var n=0;n<t.length;n++){var r=t[n],o=e>0?i:0;r.wrapShift(o),e-=r.size.outerWidth}},_unshiftCells:function(t){if(t&&t.length)for(var e=0;e<t.length;e++)t[e].wrapShift(0)},
// -------------------------- physics -------------------------- //
integratePhysics:function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},applyForce:function(t){this.velocity+=t},getFrictionFactor:function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},getRestingPosition:function(){
// my thanks to Steven Wittens, who simplified this math greatly
return this.x+this.velocity/(1-this.getFrictionFactor())},applyDragForce:function(){if(this.isDraggable&&this.isPointerDown){
// change the position to drag position by applying force
var t=this.dragX-this.x-this.velocity;this.applyForce(t)}},applySelectedAttraction:function(){if(!(this.isDraggable&&this.isPointerDown)&&!this.isFreeScrolling&&this.slides.length){var t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t)}}};return i}))})),m=createCommonjsModule((function(t){
// Flickity main
/* eslint-disable max-params */
!function(e,i){
// universal module definition
if(t.exports)
// CommonJS
t.exports=i(e,c,d,u,p,f,g);else{
// browser global
var n=e.Flickity;e.Flickity=i(e,e.EvEmitter,e.getSize,e.fizzyUIUtils,n.Cell,n.Slide,n.animatePrototype)}}(window,(function factory(t,e,i,n,r,o,s){
// vars
var a=t.jQuery,l=t.getComputedStyle,c=t.console;function moveElements(t,e){for(t=n.makeArray(t);t.length;)e.appendChild(t.shift())}
// -------------------------- Flickity -------------------------- //
// globally unique identifiers
var d=0,h={};
// internal store of all Flickity intances
function Flickity(t,e){var i=n.getQueryElement(t);if(i){
// do not initialize twice on same element
if(this.element=i,this.element.flickityGUID){var r=h[this.element.flickityGUID];return r&&r.option(e),r}
// add jQuery
a&&(this.$element=a(this.element)),
// options
this.options=n.extend({},this.constructor.defaults),this.option(e),
// kick things off
this._create()}else c&&c.error("Bad element for Flickity: "+(i||t))}Flickity.defaults={accessibility:!0,
// adaptiveHeight: false,
cellAlign:"center",
// cellSelector: undefined,
// contain: false,
freeScrollFriction:.075,// friction when free-scrolling
friction:.28,// friction when selecting
namespaceJQueryEvents:!0,
// initialIndex: 0,
percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},
// hash of methods triggered on _create()
Flickity.createMethods=[];var u=Flickity.prototype;
// inherit EventEmitter
n.extend(u,e.prototype),u._create=function(){
// add id for Flickity.data
var e=this.guid=++d;
// add listeners from on option
for(var i in this.element.flickityGUID=e,// expando
h[e]=this,// associate via id
// initial properties
this.selectedIndex=0,
// how many frames slider has been in same position
this.restingFrames=0,
// initial physics properties
this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",
// create viewport & slider
this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),(this.options.resize||this.options.watchCSS)&&t.addEventListener("resize",this),this.options.on){var n=this.options.on[i];this.on(i,n)}Flickity.createMethods.forEach((function(t){this[t]()}),this),this.options.watchCSS?this.watchCSS():this.activate()},
/**
 * set options
 * @param {Object} opts - options to extend
 */
u.option=function(t){n.extend(this.options,t)},u.activate=function(){this.isActive||(this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize(),moveElements(this._filterFindCellElements(this.element.children),this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),
// get cells from children
this.reloadCells(),this.options.accessibility&&(
// allow element to focusable
this.element.tabIndex=0,
// listen for key presses
this.element.addEventListener("keydown",this)),this.emitEvent("activate"),this.selectInitialIndex(),
// flag for initial activation, for using initialIndex
this.isInitActivated=!0,
// ready event. #493
this.dispatchEvent("ready"))},
// slider positions the cells
u._createSlider=function(){
// slider element does all the positioning
var t=document.createElement("div");t.className="flickity-slider",t.style[this.originSide]=0,this.slider=t},u._filterFindCellElements=function(t){return n.filterFindElements(t,this.options.cellSelector)},
// goes through all children
u.reloadCells=function(){
// collection of item elements
this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},
/**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */
u._makeCells=function(t){return this._filterFindCellElements(t).map((function(t){return new r(t,this)}),this)},u.getLastCell=function(){return this.cells[this.cells.length-1]},u.getLastSlide=function(){return this.slides[this.slides.length-1]},
// positions all cells
u.positionCells=function(){
// size all cells
this._sizeCells(this.cells),
// position all cells
this._positionCells(0)},
/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
u._positionCells=function(t){t=t||0,
// also measure maxCellHeight
// start 0 if positioning all cells
this.maxCellHeight=t&&this.maxCellHeight||0;var e=0;
// get cellX
if(t>0){var i=this.cells[t-1];e=i.x+i.size.outerWidth}for(var n=this.cells.length,r=t;r<n;r++){var o=this.cells[r];o.setPosition(e),e+=o.size.outerWidth,this.maxCellHeight=Math.max(o.size.outerHeight,this.maxCellHeight)}
// keep track of cellX for wrap-around
this.slideableWidth=e,
// slides
this.updateSlides(),
// contain slides target
this._containSlides(),
// update slidesWidth
this.slidesWidth=n?this.getLastSlide().target-this.slides[0].target:0},
/**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */
u._sizeCells=function(t){t.forEach((function(t){t.getSize()}))},
// --------------------------  -------------------------- //
u.updateSlides=function(){if(this.slides=[],this.cells.length){var t=new o(this);this.slides.push(t);var e="left"==this.originSide?"marginRight":"marginLeft",i=this._getCanCellFit();this.cells.forEach((function(n,r){
// just add cell if first cell in slide
if(t.cells.length){var s=t.outerWidth-t.firstMargin+(n.size.outerWidth-n.size[e]);i.call(this,r,s)||(
// doesn't fit, new slide
t.updateTarget(),t=new o(this),this.slides.push(t)),t.addCell(n)}else t.addCell(n)}),this),
// last slide
t.updateTarget(),
// update .selectedSlide
this.updateSelectedSlide()}},u._getCanCellFit=function(){var t=this.options.groupCells;if(!t)return function(){return!1};
// default, group by width of slide
// parse '75%
if("number"==typeof t){
// group by number. 3 -> [0,1,2], [3,4,5], ...
var e=parseInt(t,10);return function(t){return t%e!=0}}var i="string"==typeof t&&t.match(/^(\d+)%$/),n=i?parseInt(i[1],10)/100:1;return function(t,e){
/* eslint-disable-next-line no-invalid-this */
return e<=(this.size.innerWidth+1)*n}},
// alias _init for jQuery plugin .flickity()
u._init=u.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},u.getSize=function(){this.size=i(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var p={
// cell align, then based on origin side
center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return u.setCellAlign=function(){var t=p[this.options.cellAlign];this.cellAlign=t?t[this.originSide]:this.options.cellAlign},u.setGallerySize=function(){if(this.options.setGallerySize){var t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=t+"px"}},u._getWrapShiftCells=function(){
// only for wrap-around
if(this.options.wrapAround){
// unshift previous cells
this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);
// get before cells
// initial gap
var t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1),
// get after cells
// ending gap between last cell and end of gallery viewport
t=this.size.innerWidth-this.cursorPosition,
// start cloning at first cell, working forwards
this.afterShiftCells=this._getGapCells(t,0,1)}},u._getGapCells=function(t,e,i){for(
// keep adding cells until the cover the initial gap
var n=[];t>0;){var r=this.cells[e];if(!r)break;n.push(r),e+=i,t-=r.size.outerWidth}return n},
// ----- contain ----- //
// contain cell targets so no excess sliding
u._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var t=this.options.rightToLeft,e=t?"marginRight":"marginLeft",i=t?"marginLeft":"marginRight",n=this.slideableWidth-this.getLastCell().size[i],r=n<this.size.innerWidth,o=this.cursorPosition+this.cells[0].size[e],s=n-this.size.innerWidth*(1-this.cellAlign);
// contain each cell target
this.slides.forEach((function(t){r?
// all cells fit inside gallery
t.target=n*this.cellAlign:(
// contain to bounds
t.target=Math.max(t.target,o),t.target=Math.min(t.target,s))}),this)}},
// -----  ----- //
/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
u.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;if(this.emitEvent(t,n),a&&this.$element){var r=
// default trigger with type if no event
t+=this.options.namespaceJQueryEvents?".flickity":"";if(e){
// create jQuery event
var o=new a.Event(e);o.type=t,r=o}this.$element.trigger(r,i)}},
// -------------------------- select -------------------------- //
/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
u.select=function(t,e,i){if(this.isActive&&(t=parseInt(t,10),this._wrapSelect(t),(this.options.wrapAround||e)&&(t=n.modulo(t,this.slides.length)),this.slides[t]))
// bail if invalid index
{var r=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),
// events
this.dispatchEvent("select",null,[t]),
// change event if new index
t!=r&&this.dispatchEvent("change",null,[t]),
// old v1 event name, remove in v3
this.dispatchEvent("cellSelect")}},
// wraps position for wrapAround, to move to closest slide. #113
u._wrapSelect=function(t){var e=this.slides.length;if(!(this.options.wrapAround&&e>1))return t;var i=n.modulo(t,e),r=Math.abs(i-this.selectedIndex),o=Math.abs(i+e-this.selectedIndex),s=Math.abs(i-e-this.selectedIndex);
// go to shortest
!this.isDragSelect&&o<r?t+=e:!this.isDragSelect&&s<r&&(t-=e),
// wrap position so slider is within normal area
t<0?this.x-=this.slideableWidth:t>=e&&(this.x+=this.slideableWidth)},u.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},u.next=function(t,e){this.select(this.selectedIndex+1,t,e)},u.updateSelectedSlide=function(){var t=this.slides[this.selectedIndex];
// selectedIndex could be outside of slides, if triggered before resize()
t&&(
// unselect previous selected slide
this.unselectSelectedSlide(),
// update new selected slide
this.selectedSlide=t,t.select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),
// HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
// Remove in v3?
this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},u.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},u.selectInitialIndex=function(){var t=this.options.initialIndex;
// already activated, select previous selectedIndex
if(this.isInitActivated)this.select(this.selectedIndex,!1,!0);else{
// select with selector string
if(t&&"string"==typeof t)if(this.queryCell(t))return void this.selectCell(t,!1,!0);var e=0;
// select with number
t&&this.slides[t]&&(e=t),
// select instantly
this.select(e,!1,!0)}},
/**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */
u.selectCell=function(t,e,i){
// get cell
var n=this.queryCell(t);if(n){var r=this.getCellSlideIndex(n);this.select(r,e,i)}},u.getCellSlideIndex=function(t){
// get index of slides that has cell
for(var e=0;e<this.slides.length;e++){if(-1!=this.slides[e].cells.indexOf(t))return e}},
// -------------------------- get cells -------------------------- //
/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */
u.getCell=function(t){
// loop through cells to get the one that matches
for(var e=0;e<this.cells.length;e++){var i=this.cells[e];if(i.element==t)return i}},
/**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */
u.getCells=function(t){t=n.makeArray(t);var e=[];return t.forEach((function(t){var i=this.getCell(t);i&&e.push(i)}),this),e},
/**
 * get cell elements
 * @returns {Array} cellElems
 */
u.getCellElements=function(){return this.cells.map((function(t){return t.element}))},
/**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */
u.getParentCell=function(t){
// first check if elem is cell
var e=this.getCell(t);return e||(
// try to get parent cell elem
t=n.getParent(t,".flickity-slider > *"),this.getCell(t))},
/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
u.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;var i=this.slides.length;if(1+2*t>=i)return this.getCellElements();for(var r=[],o=e-t;o<=e+t;o++){var s=this.options.wrapAround?n.modulo(o,i):o,a=this.slides[s];a&&(r=r.concat(a.getCellElements()))}return r},
/**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */
u.queryCell=function(t){if("number"==typeof t)
// use number as index
return this.cells[t];if("string"==typeof t){
// do not select invalid selectors from hash: #123, #/. #791
if(t.match(/^[#.]?[\d/]/))return;
// use string as selector, get element
t=this.element.querySelector(t)}
// get cell from element
return this.getCell(t)},
// -------------------------- events -------------------------- //
u.uiChange=function(){this.emitEvent("uiChange")},
// keep focus on element when child UI elements are clicked
u.childUIPointerDown=function(t){
// HACK iOS does not allow touch events to bubble up?!
"touchstart"!=t.type&&t.preventDefault(),this.focus()},
// ----- resize ----- //
u.onresize=function(){this.watchCSS(),this.resize()},n.debounceMethod(Flickity,"onresize",150),u.resize=function(){
// #1177 disable resize behavior when animating or dragging for iOS 15
if(this.isActive&&!this.isAnimating&&!this.isDragging){this.getSize(),
// wrap values
this.options.wrapAround&&(this.x=n.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");
// update selected index for group slides, instant
// TODO: position can be lost between groups of various numbers
var t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)}},
// watches the :after property, activates/deactivates
u.watchCSS=function(){this.options.watchCSS&&(
// activate if :after { content: 'flickity' }
-1!=l(this.element,":after").content.indexOf("flickity")?this.activate():this.deactivate())},
// ----- keydown ----- //
// go previous/next if left/right keys pressed
u.onkeydown=function(t){
// only work if element is in focus
var e=document.activeElement&&document.activeElement!=this.element;if(this.options.accessibility&&!e){var i=Flickity.keyboardHandlers[t.keyCode];i&&i.call(this)}},Flickity.keyboardHandlers={
// left arrow
37:function(){var t=this.options.rightToLeft?"next":"previous";this.uiChange(),this[t]()},
// right arrow
39:function(){var t=this.options.rightToLeft?"previous":"next";this.uiChange(),this[t]()}},
// ----- focus ----- //
u.focus=function(){
// TODO remove scrollTo once focus options gets more support
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
//    #Browser_compatibility
var e=t.pageYOffset;this.element.focus({preventScroll:!0}),
// hack to fix scroll jump after focus, #76
t.pageYOffset!=e&&t.scrollTo(t.pageXOffset,e)},
// -------------------------- destroy -------------------------- //
// deactivate all Flickity functionality, but keep stuff available
u.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),
// destroy cells
this.cells.forEach((function(t){t.destroy()})),this.element.removeChild(this.viewport),
// move child elements back into element
moveElements(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),
// set flags
this.isActive=!1,this.emitEvent("deactivate"))},u.destroy=function(){this.deactivate(),t.removeEventListener("resize",this),this.allOff(),this.emitEvent("destroy"),a&&this.$element&&a.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete h[this.guid]},
// -------------------------- prototype -------------------------- //
n.extend(u,s),
// -------------------------- extras -------------------------- //
/**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */
Flickity.data=function(t){var e=(t=n.getQueryElement(t))&&t.flickityGUID;return e&&h[e]},n.htmlInit(Flickity,"flickity"),a&&a.bridget&&a.bridget("flickity",Flickity),
// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery=function(t){a=t},Flickity.Cell=r,Flickity.Slide=o,Flickity}))})),y=createCommonjsModule((function(t){
/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */
/*jshint browser: true, undef: true, unused: true, strict: true */
!function(e,i){
// universal module definition
/* jshint strict: false */ /*global define, module, require */
t.exports?
// CommonJS
t.exports=i(e,c):
// browser global
e.Unipointer=i(e,e.EvEmitter)}(window,(function factory(t,e){function Unipointer(){}
// inherit EvEmitter
var i=Unipointer.prototype=Object.create(e.prototype);i.bindStartEvent=function(t){this._bindStartEvent(t,!0)},i.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},
/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
i._bindStartEvent=function(e,i){var n=(
// munge isAdd, default to true
i=void 0===i||i)?"addEventListener":"removeEventListener",r="mousedown";
// default to mouse events
"ontouchstart"in t?
// HACK prefer Touch Events as you can preventDefault on touchstart to
// disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
r="touchstart":t.PointerEvent&&(
// Pointer Events
r="pointerdown"),e[n](r,this)},
// trigger handler methods for events
i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},
// returns the touch that we're keeping track of
i.getTouch=function(t){for(var e=0;e<t.length;e++){var i=t[e];if(i.identifier==this.pointerIdentifier)return i}},
// ----- start event ----- //
i.onmousedown=function(t){
// dismiss clicks from right or middle buttons
var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},i.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},i.onpointerdown=function(t){this._pointerDown(t,t)},
/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
i._pointerDown=function(t,e){
// dismiss right click and other pointers
// button = 0 is okay, 1-4 not
t.button||this.isPointerDown||(this.isPointerDown=!0,
// save pointer identifier to match up touch events
this.pointerIdentifier=void 0!==e.pointerId?
// pointerId for pointer events, touch.indentifier for touch events
e.pointerId:e.identifier,this.pointerDown(t,e))},i.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};
// hash of events to be bound after start event
var n={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};
// -----  ----- //
return i._bindPostStartEvents=function(e){if(e){
// get proper events to match start event
var i=n[e.type];
// bind events to node
i.forEach((function(e){t.addEventListener(e,this)}),this),
// save these arguments
this._boundPointerEvents=i}},i._unbindPostStartEvents=function(){
// check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
this._boundPointerEvents&&(this._boundPointerEvents.forEach((function(e){t.removeEventListener(e,this)}),this),delete this._boundPointerEvents)},
// ----- move event ----- //
i.onmousemove=function(t){this._pointerMove(t,t)},i.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},i.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},
/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
i._pointerMove=function(t,e){this.pointerMove(t,e)},
// public
i.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},
// ----- end event ----- //
i.onmouseup=function(t){this._pointerUp(t,t)},i.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},i.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},
/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
i._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},
// public
i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},
// ----- pointer done ----- //
// triggered on pointer up & pointer cancel
i._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},i._pointerReset=function(){
// reset properties
this.isPointerDown=!1,delete this.pointerIdentifier},i.pointerDone=function noop(){},
// ----- pointer cancel ----- //
i.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},i.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},
/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
i._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},
// public
i.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},
// -----  ----- //
// utility function for getting x/y coords from event
Unipointer.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},Unipointer}))})),v=createCommonjsModule((function(t){
/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */
/*jshint browser: true, unused: true, undef: true, strict: true */
!function(e,i){
// universal module definition
/*jshint strict: false */ /*globals define, module, require */
t.exports?
// CommonJS
t.exports=i(e,y):
// browser global
e.Unidragger=i(e,e.Unipointer)}(window,(function factory(t,e){
// -------------------------- Unidragger -------------------------- //
function Unidragger(){}
// inherit Unipointer & EvEmitter
var i=Unidragger.prototype=Object.create(e.prototype);
// ----- bind start ----- //
i.bindHandles=function(){this._bindHandles(!0)},i.unbindHandles=function(){this._bindHandles(!1)},
/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
i._bindHandles=function(e){for(
// bind each handle
var i=(
// munge isAdd, default to true
e=void 0===e||e)?"addEventListener":"removeEventListener",n=e?this._touchActionValue:"",r=0;r<this.handles.length;r++){var o=this.handles[r];this._bindStartEvent(o,e),o[i]("click",this),
// touch-action: none to override browser touch gestures. metafizzy/flickity#540
t.PointerEvent&&(o.style.touchAction=n)}},
// prototype so it can be overwriteable by Flickity
i._touchActionValue="none",
// ----- start event ----- //
/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
i.pointerDown=function(t,e){this.okayPointerDown(t)&&(
// track start event position
// Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},t.preventDefault(),this.pointerDownBlur(),
// bind move and end events
this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};
// nodes that have text fields
var n={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},r={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};
// input types that do not have text fields
// -----  ----- //
// dismiss inputs with text fields. flickity#403, flickity#404
return i.okayPointerDown=function(t){var e=n[t.target.nodeName],i=r[t.target.type],o=!e||i;return o||this._pointerReset(),o},
// kludge to blur previously focused input
i.pointerDownBlur=function(){var t=document.activeElement;
// do not blur body for IE10, metafizzy/flickity#117
t&&t.blur&&t!=document.body&&t.blur()},
// ----- move event ----- //
/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
i.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},
// base pointer move logic
i._dragPointerMove=function(t,e){var i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};
// start drag if pointer has moved far enough to start drag
return!this.isDragging&&this.hasDragStarted(i)&&this._dragStart(t,e),i},
// condition if pointer has moved far enough to start drag
i.hasDragStarted=function(t){return Math.abs(t.x)>3||Math.abs(t.y)>3},
// ----- end event ----- //
/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},i._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):
// pointer didn't move enough for drag to start
this._staticClick(t,e)},
// -------------------------- drag -------------------------- //
// dragStart
i._dragStart=function(t,e){this.isDragging=!0,
// prevent clicks
this.isPreventingClicks=!0,this.dragStart(t,e)},i.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},
// dragMove
i._dragMove=function(t,e,i){
// do not drag if not dragging yet
this.isDragging&&this.dragMove(t,e,i)},i.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},
// dragEnd
i._dragEnd=function(t,e){
// set flags
this.isDragging=!1,
// re-enable clicking async
setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},i.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},
// ----- onclick ----- //
// handle all clicks and prevent clicks when dragging
i.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},
// ----- staticClick ----- //
// triggered after pointer down & up with no/tiny movement
i._staticClick=function(t,e){
// ignore emulated mouse up clicks
this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),
// set flag for emulated clicks 300ms after touchend
"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,
// reset flag after 300ms
setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},i.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},
// ----- utils ----- //
Unidragger.getPointerPoint=e.getPointerPoint,Unidragger}))})),w=(createCommonjsModule((function(t){
// drag
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(e,m,v,u):
// browser global
e.Flickity=i(e,e.Flickity,e.Unidragger,e.fizzyUIUtils)}(window,(function factory(t,e,i,n){
// ----- defaults ----- //
n.extend(e.defaults,{draggable:">1",dragThreshold:3}),
// ----- create ----- //
e.createMethods.push("_createDrag");
// -------------------------- drag prototype -------------------------- //
var r=e.prototype;n.extend(r,i.prototype),r._touchActionValue="pan-y",
// --------------------------  -------------------------- //
r._createDrag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable)},r.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},r.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},r.updateDraggable=function(){
// disable dragging if less than 2 slides. #278
">1"==this.options.draggable?this.isDraggable=this.slides.length>1:this.isDraggable=this.options.draggable,this.isDraggable?this.element.classList.add("is-draggable"):this.element.classList.remove("is-draggable")},
// backwards compatibility
r.bindDrag=function(){this.options.draggable=!0,this.updateDraggable()},r.unbindDrag=function(){this.options.draggable=!1,this.updateDraggable()},r._uiChangeDrag=function(){delete this.isFreeScrolling},
// -------------------------- pointer events -------------------------- //
r.pointerDown=function(e,i){this.isDraggable?this.okayPointerDown(e)&&(this._pointerDownPreventDefault(e),this.pointerDownFocus(e),
// blur
document.activeElement!=this.element&&
// do not blur if already focused
this.pointerDownBlur(),
// stop if it was moving
this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),
// track scrolling
this.pointerDownScroll=getScrollPosition(),t.addEventListener("scroll",this),this._pointerDownDefault(e,i)):this._pointerDownDefault(e,i)},
// default pointerDown logic, used for staticClick
r._pointerDownDefault=function(t,e){
// track start event position
// Safari 9 overrides pageX and pageY. These values needs to be copied. #779
this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},
// bind move and end events
this._bindPostStartEvents(t),this.dispatchEvent("pointerDown",t,[e])};var o={INPUT:!0,TEXTAREA:!0,SELECT:!0};
// ----- utils ----- //
function getScrollPosition(){return{x:t.pageXOffset,y:t.pageYOffset}}
// -----  ----- //
return r.pointerDownFocus=function(t){o[t.target.nodeName]||this.focus()},r._pointerDownPreventDefault=function(t){var e="touchstart"==t.type,i="touch"==t.pointerType,n=o[t.target.nodeName];e||i||n||t.preventDefault()},
// ----- move ----- //
r.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},
// ----- up ----- //
r.pointerUp=function(t,e){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",t,[e]),this._dragPointerUp(t,e)},r.pointerDone=function(){t.removeEventListener("scroll",this),delete this.pointerDownScroll},
// -------------------------- dragging -------------------------- //
r.dragStart=function(e,i){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),t.removeEventListener("scroll",this),this.dispatchEvent("dragStart",e,[i]))},r.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.dispatchEvent("pointerMove",t,[e,i]),this._dragMove(t,e,i)},r.dragMove=function(t,e,i){if(this.isDraggable){t.preventDefault(),this.previousDragX=this.dragX;
// reverse if right-to-left
var n=this.options.rightToLeft?-1:1;this.options.wrapAround&&(
// wrap around move. #589
i.x%=this.slideableWidth);var r=this.dragStartPosition+i.x*n;if(!this.options.wrapAround&&this.slides.length){
// slow drag
var o=Math.max(-this.slides[0].target,this.dragStartPosition);r=r>o?.5*(r+o):r;var s=Math.min(-this.getLastSlide().target,this.dragStartPosition);r=r<s?.5*(r+s):r}this.dragX=r,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",t,[e,i])}},r.dragEnd=function(t,e){if(this.isDraggable){this.options.freeScroll&&(this.isFreeScrolling=!0);
// set selectedIndex based on where flick will end up
var i=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){
// if free-scroll & not wrap around
// do not free-scroll if going outside of bounding slides
// so bounding slides can attract slider, and keep it in bounds
var n=this.getRestingPosition();this.isFreeScrolling=-n>this.slides[0].target&&-n<this.getLastSlide().target}else this.options.freeScroll||i!=this.selectedIndex||(
// boost selection if selected index has not changed
i+=this.dragEndBoostSelect());delete this.previousDragX,
// apply selection
// TODO refactor this, selecting here feels weird
// HACK, set flag so dragging stays in correct direction
this.isDragSelect=this.options.wrapAround,this.select(i),delete this.isDragSelect,this.dispatchEvent("dragEnd",t,[e])}},r.dragEndRestingSelect=function(){var t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),n=this._getClosestResting(t,e,-1);
// how far away from selected slide
return i.distance<n.distance?i.index:n.index},
/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
r._getClosestResting=function(t,e,i){for(var n=this.selectedIndex,r=Infinity,o=this.options.contain&&!this.options.wrapAround?
// if contain, keep going if distance is equal to minDistance
function(t,e){return t<=e}:function(t,e){return t<e};o(e,r)&&(
// measure distance to next cell
n+=i,r=e,null!==(e=this.getSlideDistance(-t,n)));)e=Math.abs(e);return{distance:r,
// selected was previous index
index:n-i}},
/**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */
r.getSlideDistance=function(t,e){var i=this.slides.length,r=this.options.wrapAround&&i>1,o=r?n.modulo(e,i):e,s=this.slides[o];
// wrap around if at least 2 slides
if(!s)return null;
// add distance for wrap-around slides
var a=r?this.slideableWidth*Math.floor(e/i):0;return t-(s.target+a)},r.dragEndBoostSelect=function(){
// do not boost if no previousDragX or dragMoveTime
if(void 0===this.previousDragX||!this.dragMoveTime||
// or if drag was held for 100 ms
new Date-this.dragMoveTime>100)return 0;var t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return t>0&&e>0?1:t<0&&e<0?-1:0},
// ----- staticClick ----- //
r.staticClick=function(t,e){
// get clickedCell, if cell was clicked
var i=this.getParentCell(t.target),n=i&&i.element,r=i&&this.cells.indexOf(i);this.dispatchEvent("staticClick",t,[e,n,r])},
// ----- scroll ----- //
r.onscroll=function(){var t=getScrollPosition(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;
// cancel click/tap if scroll is too much
(Math.abs(e)>3||Math.abs(i)>3)&&this._pointerDone()},e}))})),createCommonjsModule((function(t){
// prev/next buttons
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(e,m,y,u):
// browser global
i(e,e.Flickity,e.Unipointer,e.fizzyUIUtils)}(window,(function factory(t,e,i,n){var r="http://www.w3.org/2000/svg";
// -------------------------- PrevNextButton -------------------------- //
function PrevNextButton(t,e){this.direction=t,this.parent=e,this._create()}PrevNextButton.prototype=Object.create(i.prototype),PrevNextButton.prototype._create=function(){
// properties
this.isEnabled=!0,this.isPrevious=-1==this.direction;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-button flickity-prev-next-button",e.className+=this.isPrevious?" previous":" next",
// prevent button from submitting form http://stackoverflow.com/a/10836076/182183
e.setAttribute("type","button"),
// init as disabled
this.disable(),e.setAttribute("aria-label",this.isPrevious?"Previous":"Next");
// create arrow
var i=this.createSVG();e.appendChild(i),
// events
this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},PrevNextButton.prototype.activate=function(){this.bindStartEvent(this.element),this.element.addEventListener("click",this),
// add to DOM
this.parent.element.appendChild(this.element)},PrevNextButton.prototype.deactivate=function(){
// remove from DOM
this.parent.element.removeChild(this.element),
// click events
this.unbindStartEvent(this.element),this.element.removeEventListener("click",this)},PrevNextButton.prototype.createSVG=function(){var t=document.createElementNS(r,"svg");t.setAttribute("class","flickity-button-icon"),t.setAttribute("viewBox","0 0 100 100");var e=document.createElementNS(r,"path"),i=
// get SVG path movmement
function getArrowMovements(t){
// use shape as movement if string
if("string"==typeof t)return t;
// create movement string
return"M "+t.x0+",50 L "+t.x1+","+(t.y1+50)+" L "+t.x2+","+(t.y2+50)+" L "+t.x3+",50  L "+t.x2+","+(50-t.y2)+" L "+t.x1+","+(50-t.y1)+" Z"}(this.parent.options.arrowShape);return e.setAttribute("d",i),e.setAttribute("class","arrow"),
// rotate arrow
this.isLeft||e.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(e),t},PrevNextButton.prototype.handleEvent=n.handleEvent,PrevNextButton.prototype.onclick=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},
// -----  ----- //
PrevNextButton.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},PrevNextButton.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},PrevNextButton.prototype.update=function(){
// index of first or last slide, if previous or next
var t=this.parent.slides;
// enable is wrapAround and at least 2 slides
if(this.parent.options.wrapAround&&t.length>1)this.enable();else{var e=t.length?t.length-1:0,i=this.isPrevious?0:e;this[this.parent.selectedIndex==i?"disable":"enable"]()}},PrevNextButton.prototype.destroy=function(){this.deactivate(),this.allOff()},
// -------------------------- Flickity prototype -------------------------- //
n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var o=e.prototype;return o._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new PrevNextButton(-1,this),this.nextButton=new PrevNextButton(1,this),this.on("activate",this.activatePrevNextButtons))},o.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},o.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},
// --------------------------  -------------------------- //
e.PrevNextButton=PrevNextButton,e}))})),createCommonjsModule((function(t){
// page dots
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(e,m,y,u):
// browser global
i(e,e.Flickity,e.Unipointer,e.fizzyUIUtils)}(window,(function factory(t,e,i,n){function PageDots(t){this.parent=t,this._create()}PageDots.prototype=Object.create(i.prototype),PageDots.prototype._create=function(){
// create holder element
this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",
// create dots, array of elements
this.dots=[],
// events
this.handleClick=this.onClick.bind(this),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},PageDots.prototype.activate=function(){this.setDots(),this.holder.addEventListener("click",this.handleClick),this.bindStartEvent(this.holder),
// add to DOM
this.parent.element.appendChild(this.holder)},PageDots.prototype.deactivate=function(){this.holder.removeEventListener("click",this.handleClick),this.unbindStartEvent(this.holder),
// remove from DOM
this.parent.element.removeChild(this.holder)},PageDots.prototype.setDots=function(){
// get difference between number of slides and number of dots
var t=this.parent.slides.length-this.dots.length;t>0?this.addDots(t):t<0&&this.removeDots(-t)},PageDots.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[],n=this.dots.length,r=n+t,o=n;o<r;o++){var s=document.createElement("li");s.className="dot",s.setAttribute("aria-label","Page dot "+(o+1)),e.appendChild(s),i.push(s)}this.holder.appendChild(e),this.dots=this.dots.concat(i)},PageDots.prototype.removeDots=function(t){
// remove from DOM
this.dots.splice(this.dots.length-t,t).forEach((function(t){this.holder.removeChild(t)}),this)},PageDots.prototype.updateSelected=function(){
// remove selected class on previous
this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),
// don't proceed if no dots
this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},PageDots.prototype.onTap=// old method name, backwards-compatible
PageDots.prototype.onClick=function(t){var e=t.target;
// only care about dot clicks
if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},PageDots.prototype.destroy=function(){this.deactivate(),this.allOff()},e.PageDots=PageDots,
// -------------------------- Flickity -------------------------- //
n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var r=e.prototype;return r._createPageDots=function(){this.options.pageDots&&(this.pageDots=new PageDots(this),
// events
this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},r.activatePageDots=function(){this.pageDots.activate()},r.updateSelectedPageDots=function(){this.pageDots.updateSelected()},r.updatePageDots=function(){this.pageDots.setDots()},r.deactivatePageDots=function(){this.pageDots.deactivate()},
// -----  ----- //
e.PageDots=PageDots,e}))})),createCommonjsModule((function(t){
// player & autoPlay
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(c,u,m):
// browser global
i(e.EvEmitter,e.fizzyUIUtils,e.Flickity)}(window,(function factory(t,e,i){
// -------------------------- Player -------------------------- //
function Player(t){this.parent=t,this.state="stopped",
// visibility change event handler
this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}Player.prototype=Object.create(t.prototype),
// start play
Player.prototype.play=function(){"playing"!=this.state&&(document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",
// listen to visibility change
document.addEventListener("visibilitychange",this.onVisibilityChange),
// start ticking
this.tick()));
// do not play if page is hidden, start playing when page is visible
},Player.prototype.tick=function(){
// do not tick if not playing
if("playing"==this.state){var t=this.parent.options.autoPlay;
// default to 3 seconds
t="number"==typeof t?t:3e3;var e=this;
// HACK: reset ticks if stopped and started within interval
this.clear(),this.timeout=setTimeout((function(){e.parent.next(!0),e.tick()}),t)}},Player.prototype.stop=function(){this.state="stopped",this.clear(),
// remove visibility change event
document.removeEventListener("visibilitychange",this.onVisibilityChange)},Player.prototype.clear=function(){clearTimeout(this.timeout)},Player.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},Player.prototype.unpause=function(){
// re-start play if paused
"paused"==this.state&&this.play()},
// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},Player.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},
// -------------------------- Flickity -------------------------- //
e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var n=i.prototype;return n._createPlayer=function(){this.player=new Player(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},n.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},
// Player API, don't hate the ... thanks I know where the door is
n.playPlayer=function(){this.player.play()},n.stopPlayer=function(){this.player.stop()},n.pausePlayer=function(){this.player.pause()},n.unpausePlayer=function(){this.player.unpause()},n.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},
// ----- mouseenter/leave ----- //
// pause auto-play on hover
n.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},
// resume auto-play on hover off
n.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},
// -----  ----- //
i.Player=Player,i}))})),createCommonjsModule((function(t){
// add, remove cell
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(e,m,u):
// browser global
i(e,e.Flickity,e.fizzyUIUtils)}(window,(function factory(t,e,i){
// -------------------------- add/remove cell prototype -------------------------- //
var n=e.prototype;
/**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */
// -----  ----- //
return n.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var n=this.cells.length;
// default to append
e=void 0===e?n:e;
// add cells with document fragment
var r=
// append cells to a document fragment
function getCellsFragment(t){var e=document.createDocumentFragment();return t.forEach((function(t){e.appendChild(t.element)})),e}(i),o=e==n;
// append to slider
if(o)this.slider.appendChild(r);else{var s=this.cells[e].element;this.slider.insertBefore(r,s)}
// add to this.cells
if(0===e)
// prepend, add to start
this.cells=i.concat(this.cells);else if(o)
// append, add to end
this.cells=this.cells.concat(i);else{
// insert in this.cells
var a=this.cells.splice(e,n-e);this.cells=this.cells.concat(i).concat(a)}this._sizeCells(i),this.cellChange(e,!0)}},n.append=function(t){this.insert(t,this.cells.length)},n.prepend=function(t){this.insert(t,0)},
/**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */
n.remove=function(t){var e=this.getCells(t);if(e&&e.length){var n=this.cells.length-1;
// remove cells from collection & DOM
e.forEach((function(t){t.remove();var e=this.cells.indexOf(t);n=Math.min(e,n),i.removeFrom(this.cells,t)}),this),this.cellChange(n,!0)}},
/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
n.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},
/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */
n.cellChange=function(t,e){var i=this.selectedElement;this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize();
// update selectedIndex
// try to maintain position & select previous selected element
var n=this.getCell(i);n&&(this.selectedIndex=this.getCellSlideIndex(n)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),
// position slider
this.select(this.selectedIndex),
// do not position slider after lazy load
e&&this.positionSliderAtSelected()},e}))})),createCommonjsModule((function(t){
// lazyload
!function(e,i){
// universal module definition
t.exports?
// CommonJS
t.exports=i(e,m,u):
// browser global
i(e,e.Flickity,e.fizzyUIUtils)}(window,(function factory(t,e,i){e.createMethods.push("_createLazyload");var n=e.prototype;
// -------------------------- LazyLoader -------------------------- //
/**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */
function LazyLoader(t,e){this.img=t,this.flickity=e,this.load()}return n._createLazyload=function(){this.on("select",this.lazyLoad)},n.lazyLoad=function(){var t=this.options.lazyLoad;if(t){
// get adjacent cells, use lazyLoad option for adjacent count
var e="number"==typeof t?t:0,n=this.getAdjacentCellElements(e),r=[];n.forEach((function(t){var e=function getCellLazyImages(t){
// check if cell element is lazy image
if("IMG"==t.nodeName){var e=t.getAttribute("data-flickity-lazyload"),n=t.getAttribute("data-flickity-lazyload-src"),r=t.getAttribute("data-flickity-lazyload-srcset");if(e||n||r)return[t]}
// select lazy images in cell
var o="img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]",s=t.querySelectorAll(o);return i.makeArray(s)}(t);r=r.concat(e)})),
// load lazy images
r.forEach((function(t){new LazyLoader(t,this)}),this)}},LazyLoader.prototype.handleEvent=i.handleEvent,LazyLoader.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this);
// get src & srcset
var t=this.img.getAttribute("data-flickity-lazyload")||this.img.getAttribute("data-flickity-lazyload-src"),e=this.img.getAttribute("data-flickity-lazyload-srcset");
// set src & serset
this.img.src=t,e&&this.img.setAttribute("srcset",e),
// remove attr
this.img.removeAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload-src"),this.img.removeAttribute("data-flickity-lazyload-srcset")},LazyLoader.prototype.onload=function(t){this.complete(t,"flickity-lazyloaded")},LazyLoader.prototype.onerror=function(t){this.complete(t,"flickity-lazyerror")},LazyLoader.prototype.complete=function(t,e){
// unbind events
this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var i=this.flickity.getParentCell(this.img),n=i&&i.element;this.flickity.cellSizeChange(n),this.img.classList.add(e),this.flickity.dispatchEvent("lazyLoad",t,n)},
// -----  ----- //
e.LazyLoader=LazyLoader,e}))})),createCommonjsModule((function(t){
/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */
window,
// universal module definition
t.exports&&(
// CommonJS
t.exports=m)})));
/* harmony default export */const b=function(){function ComplementaryProducts(t){!function _classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,ComplementaryProducts),this.sectionEl=t.sectionEl,this.sectionId=t.sectionId,this.events=new s,this.productId=t.productId,this.includeIndicatorDots=t.includeIndicatorDots||!1,this.recommendationsRoute=t.productRecommendationsRoute,this.limit=t.limit;this.arrowShape=t.arrowShape||{x0:10,x1:60,y1:50,x2:65,y2:45,x3:20},this.recommendationsEl=this.sectionEl.querySelector("[data-complementary-products]"),this.loadRecommendations()}return function _createClass(t,e,i){return e&&_defineProperties(t.prototype,e),i&&_defineProperties(t,i),Object.defineProperty(t,"prototype",{writable:!1}),t}(ComplementaryProducts,[{key:"loadRecommendations",value:function loadRecommendations(){var t=this,e="".concat(this.recommendationsRoute,"?section_id=").concat(this.sectionId,"&limit=").concat(this.limit,"&product_id=").concat(this.productId,"&intent=complementary");l.load(e,{view:""}).then((function(e){var i=e.html;if("object"!==_typeof(i)||0!==Object.keys(i).length)if(0!==i.trim().length){t.recommendationsEl.innerHTML=i,n.instance||n.init(),n.watch(t.recommendationsEl);var r=t.recommendationsEl.querySelector("[data-slider]");t.recommendationsEl.querySelectorAll("[data-slide]").length>1&&(t.slider=new w(r,{cellSelector:"[data-slide]",accessibility:!1,adaptiveHeight:!1,autoPlay:!1,cellAlign:"left",contain:!0,imagesLoaded:!0,pageDots:t.includeIndicatorDots,wrapAround:!0,arrowShape:t.arrowShape}),t.events.register(r,"rimg:load",(function(){t.slider.resize()})))}else t.recommendationsEl.classList.add("complementary-products--no-recommendations")}))}},{key:"unload",value:function unload(){this.slider.destroy()}}]),ComplementaryProducts}(),_="pxu-shopify-surface-pick-up",S="surface-pick-up--loading";async function getLocation(t=!1){const e=JSON.parse(localStorage.getItem(_));return e&&e.timestamp+36e5>=Date.now()?e:t?async function getGeoLocation(){return new Promise(((t,e)=>{const i={maximumAge:36e5,
// 1 hour
timeout:5e3};navigator.geolocation?navigator.geolocation.getCurrentPosition((({coords:e})=>t(e)),e,i):e()}))}().then((t=>(async function setLocation({latitude:t,longitude:e}){const i={latitude:t,longitude:e,timestamp:Date.now()};return localStorage.setItem(_,JSON.stringify(i)),fetch("/localization.json",{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({latitude:t,longitude:e})}).then((()=>({latitude:t,longitude:e})))}(t),t))):null}
/* harmony default export */const x=class SurfacePickUp{constructor(t,e){this.el=t,this.options={root_url:window.Theme&&window.Theme.routes&&window.Theme.routes.root_url||"",...e},this.options.root_url=this.options.root_url.replace(/(.*)\/$/,"$1"),this.callbacks=[],this.onBtnPress=null,this.latestVariantId=null}load(t){
// If no variant is available, empty element and quick-return
return t?(// Because Shopify doesn't expose any `pick_up_enabled` data on the shop object, we
// don't know if the variant might be, or is definitely not available for pick up.
// Until we know the shop has > 0 pick up locations, we want to avoid prompting the
// user for location data (it's annoying, and only makes sense to do if we use it).
// Instead, we have to make an initial request, check and see if any pick up locations
// were returned, then ask for the users location, then make another request to get the
// location-aware pick up locations.
// As far as I can tell the pick up aware locations differ only in sort order - which
// we could do on the front end - but we're following this approach to ensure future
// compatibility with any changes Shopify makes (maybe disabling options based on
// user location, or whatever else).
// Shopify has indicated they will look into adding pick_up_enabled data to the shop
// object, which which case this method can be greatly simplifed into 2 simple cases.
this.latestVariantId=t,this.el.classList.add(S),this._getData(t).then((t=>this._injectData(t)))):(this.el.innerHTML="",Promise.resolve(!0))}onModalRequest(t){this.callbacks.indexOf(t)>=0||this.callbacks.push(t)}offModalRequest(t){this.callbacks.splice(this.callbacks.indexOf(t))}unload(){this.callbacks=[],this.el.innerHTML=""}_getData(t){return new Promise((e=>{const i=new XMLHttpRequest,n=`${this.options.root_url}/variants/${t}/?section_id=surface-pick-up`;i.open("GET",n,!0),i.onload=()=>{const n=i.response,r=n.querySelector('[data-html="surface-pick-up-embed"]'),o=n.querySelector('[data-html="surface-pick-up-items"]'),s=o.content.querySelectorAll("[data-surface-pick-up-item]");e({embed:r,itemsContainer:o,items:s,variantId:t})},i.onerror=()=>{e({embed:{innerHTML:""},itemsContainer:{innerHTML:""},items:[],variantId:t})},i.responseType="document",i.send()}))}_injectData({embed:t,itemsContainer:e,items:i,variantId:n}){if(n!==this.latestVariantId||0===i.length)return this.el.innerHTML="",void this.el.classList.remove(S);this.el.innerHTML=t.innerHTML,this.el.classList.remove(S);let r=!1;const calculateDistances=()=>r?Promise.resolve():getLocation(!0).then((t=>{i.forEach((e=>{const i=e.querySelector("[data-distance]"),n=e.querySelector("[data-distance-unit]"),r=n.dataset.distanceUnit,o=parseFloat(i.dataset.latitude),s=parseFloat(i.dataset.longitude);if(t&&isFinite(o)&&isFinite(s)){const e=// Haversine Distance
// The haversine formula is an equation giving great-circle distances between
// two points on a sphere from their longitudes and latitudes
function calculateDistance(t,e,i,n,r){const o=Math.PI/180,s="metric"===r?6378.14:3959,a=t*o,l=i*o,c=e*o-n*o,d=a-l,h=Math.sin(d/2)**2+Math.cos(a)*Math.cos(l)*Math.sin(c/2)**2;return s*(2*Math.atan2(Math.sqrt(h),Math.sqrt(1-h)))}(t.latitude,t.longitude,o,s,r);i.innerHTML=e.toFixed(1)}else i.remove(),n.remove()}))})).catch((t=>{console.log(t),i.forEach((t=>{const e=t.querySelector("[data-distance]"),i=t.querySelector("[data-distance-unit]");e.remove(),i.remove()}))})).finally((()=>{r=!0}));this.el.querySelector("[data-surface-pick-up-embed-modal-btn]").addEventListener("click",(()=>{calculateDistances().then((()=>this.callbacks.forEach((t=>t(e.innerHTML)))))}))}};// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-price-ui/dist/index.es.js
function index_es_classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function index_es_defineProperties(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function index_es_createClass(t,e,i){return e&&index_es_defineProperties(t.prototype,e),i&&index_es_defineProperties(t,i),t}function index_es_defineProperty(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function index_es_ownKeys(t,e){var i=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),i.push.apply(i,n)}return i}function index_es_objectSpread2(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{};e%2?index_es_ownKeys(Object(i),!0).forEach((function(e){index_es_defineProperty(t,e,i[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):index_es_ownKeys(Object(i)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e))}))}return t}var P=document.getElementById("price-ui").content,E=document.getElementById("price-ui__price").content,C=document.getElementById("price-ui__price-range").content,k=document.getElementById("price-ui__unit-pricing").content;function createPriceRangeFragment(t,e,i){var n=C.cloneNode(!0);return n.querySelector("[data-price-min] [data-price]").innerHTML=i(t),n.querySelector("[data-price-max] [data-price]").innerHTML=i(e),n}function createPriceFragment(t,e){var i=E.cloneNode(!0);return i.querySelector("[data-price]").innerHTML=e(t),i}var D=function(){function PriceUI(t){index_es_classCallCheck(this,PriceUI),this._el=t}return index_es_createClass(PriceUI,[{key:"load",value:function load(t,e){var i=index_es_objectSpread2({variant:!1,formatter:function formatter(t){return t},handler:function handler(t){return t}},e),n=i.variant,r=i.formatter,o=i.handler;this._el.classList.add("price-ui--loading");var s=o(n?this._loadVariant(n,r):this._loadProduct(t,r),t,e);this._el.innerHTML="",this._el.appendChild(s),this._el.classList.remove("price-ui--loading")}},{key:"_loadVariant",value:function _loadVariant(t,e){var i=P.cloneNode(!0),n=i.querySelector("[data-compare-at-price]"),r=i.querySelector("[data-price]"),o=i.querySelector("[data-unit-pricing]");if(t.compare_at_price&&t.compare_at_price!==t.price){r.classList.add("price--sale");var s=createPriceFragment(t.compare_at_price,e);n.appendChild(s)}var a=createPriceFragment(t.price,e);if(r.appendChild(a),"unit_price"in t){var l=function createUnitPricing(t,e){var i=k.cloneNode(!0),n=i.querySelector("[data-unit-quantity]"),r=i.querySelector("[data-unit-price] [data-price]"),o=i.querySelector("[data-unit-measurement]");return n.innerHTML="".concat(t.unit_price_measurement.quantity_value).concat(t.unit_price_measurement.quantity_unit),r.innerHTML=e(t.unit_price),1===t.unit_price_measurement.reference_value?o.innerHTML=t.unit_price_measurement.reference_unit:o.innerHTML="".concat(t.unit_price_measurement.reference_value).concat(t.unit_price_measurement.reference_unit),i}(t,e);o.appendChild(l)}return i}},{key:"_loadProduct",value:function _loadProduct(t,e){var i,n,r=null,o=null,s=null,a=null,l=!1;t.variants.forEach((function(t){
// Use variant price as compare_at_price if compare_at_price is unavailable
var e=t.compare_at_price?t.compare_at_price:t.price;// Determine price min
(null===r||t.price<r)&&(r=t.price),// Determine price max
(null===o||t.price>o)&&(o=t.price),// Determine compare_at_price min
(null===s||e<s)&&(s=e),// Determine compare_at_price max
(null===a||e>a)&&(a=e),e!==t.price&&(l=!0)})),i=r!==o,n=s!==a;var c=P.cloneNode(!0),d=c.querySelector("[data-compare-at-price]"),h=c.querySelector("[data-price]");if(l)if(h.classList.add("price--sale"),n){var u=createPriceRangeFragment(s,a,e);d.appendChild(u)}else{var p=createPriceFragment(s,e);d.appendChild(p)}if(i){var f=createPriceRangeFragment(r,o,e);h.appendChild(f)}else{var g=createPriceFragment(r,e);h.appendChild(g)}return c}}]),PriceUI}();document.getElementById("price-ui-badge").content,document.getElementById("price-ui-badge__percent-savings").content,document.getElementById("price-ui-badge__percent-savings-range").content,document.getElementById("price-ui-badge__price-savings").content,document.getElementById("price-ui-badge__price-savings-range").content,document.getElementById("price-ui-badge__on-sale").content,document.getElementById("price-ui-badge__sold-out").content,document.getElementById("price-ui-badge__in-stock").content;function dist_index_es_defineProperties(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function dist_index_es_defineProperty(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function dist_index_es_ownKeys(t,e){var i=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),i.push.apply(i,n)}return i}function index_es_slicedToArray(t,e){return function index_es_arrayWithHoles(t){if(Array.isArray(t))return t}(t)||function index_es_iterableToArrayLimit(t,e){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(t)))return;var i=[],n=!0,r=!1,o=void 0;try{for(var s,a=t[Symbol.iterator]();!(n=(s=a.next()).done)&&(i.push(s.value),!e||i.length!==e);n=!0);}catch(t){r=!0,o=t}finally{try{n||null==a.return||a.return()}finally{if(r)throw o}}return i}(t,e)||function index_es_unsupportedIterableToArray(t,e){if(!t)return;if("string"==typeof t)return index_es_arrayLikeToArray(t,e);var i=Object.prototype.toString.call(t).slice(8,-1);"Object"===i&&t.constructor&&(i=t.constructor.name);if("Map"===i||"Set"===i)return Array.from(i);if("Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))return index_es_arrayLikeToArray(t,e)}(t,e)||function index_es_nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function index_es_arrayLikeToArray(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n}var L={},A=function(){function AsyncView(){!// CONCATENATED MODULE: ./node_modules/@pixelunion/shopify-asyncview/dist/index.es.js
/*!
   * @pixelunion/shopify-asyncview v2.0.5
   * (c) 2020 Pixel Union
  */
function dist_index_es_classCallCheck(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,AsyncView)}return function dist_index_es_createClass(t,e,i){return e&&dist_index_es_defineProperties(t.prototype,e),i&&dist_index_es_defineProperties(t,i),t}(AsyncView,null,[{key:"load",
/**
     * Load the template given by the provided URL into the provided
     * view
     *
     * @param {string} url - The url to load
     * @param {object} query - An object containing additional query parameters of the URL
     * @param {string} query.view - A required query parameter indicating which view to load
     * @param {object} [options] - Config options
     * @param {string} [options.hash] - A hash of the current page content
     */
value:function load(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!("view"in e))return Promise.reject(new Error("'view' not found in 'query' parameter"));var n=t.replace(/\?[^#]+/,""),r=new RegExp(/.+\?([^#]+)/).exec(t),o=e;r&&r.length>=2&&r[1].split("&").forEach((function(t){var e=index_es_slicedToArray(t.split("="),2),i=e[0],n=e[1];o[i]=n}));// NOTE: We're adding an additional timestamp to the query.
// This is to prevent certain browsers from returning cached
// versions of the url we are requesting.
// See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
var s=function dist_index_es_objectSpread2(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{};e%2?dist_index_es_ownKeys(Object(i),!0).forEach((function(e){dist_index_es_defineProperty(t,e,i[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):dist_index_es_ownKeys(Object(i)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e))}))}return t}({},o,{_:(new Date).getTime()}),a=n.replace(/([^#]+)(.*)/,(function(t,e,i){return"".concat(e,"?").concat(Object.keys(o).sort().map((function(t){return"".concat(t,"=").concat(encodeURIComponent(o[t]))})).join("&")).concat(i)})),l=n.replace(/([^#]+)(.*)/,(function(t,e,i){return"".concat(e,"?").concat(Object.keys(s).sort().map((function(t){return"".concat(t,"=").concat(encodeURIComponent(s[t]))})).join("&")).concat(i)})),c=new Promise((function(t,e){var n;if(a in L)t(L[a]);else{if(L[a]=c,i.hash&&(n=sessionStorage.getItem(a))){var r=JSON.parse(n);if(i.hash===r.options.hash)return delete L[a],void t(r)}var o=new XMLHttpRequest;o.open("GET",l,!0),o.onload=function(){var e=o.response,n={},r=e.querySelector("[data-options]");r&&r.innerHTML&&(n=JSON.parse(e.querySelector("[data-options]").innerHTML));var s=e.querySelectorAll("[data-html]"),l={};if(1===s.length&&""===s[0].getAttribute("data-html"))l=s[0].innerHTML;else for(var c=0;c<s.length;c++)l[s[c].getAttribute("data-html")]=s[c].innerHTML;var d=e.querySelectorAll("[data-data]"),h={};if(1===d.length&&""===d[0].getAttribute("data-data"))h=JSON.parse(d[0].innerHTML);else for(var u=0;u<d.length;u++)h[d[u].getAttribute("data-data")]=JSON.parse(d[u].innerHTML);if(i.hash)try{sessionStorage.setItem(a,JSON.stringify({options:n,data:h,html:l}))}catch(t){console.error(t)}delete L[a],t({data:h,html:l})},o.onerror=function(){delete L[a],e()},o.responseType="document",o.send()}}));return c}}]),AsyncView}();
/* harmony default export */const I=A;// CONCATENATED MODULE: ./source/scripts/sections/jsProduct.js
class Product{static load(t){return I.load(t,// template name
{view:"quickshop"})}constructor(t){
// Add settings from schema to current object
this._section=t[0],this._data=window.PXUTheme.getSectionData(t),
// Ensure product media libraries are present
window.Shopify.loadFeatures([{name:"shopify-xr",version:"1.0"},{name:"model-viewer-ui",version:"1.0"}],window.PXUTheme.productMedia.setupMedia);const e=t[0].querySelector("[data-price-ui]"),i=t[0].querySelector("[data-surface-pick-up]"),n=t[0].querySelector("[data-complementary-products]");this.variantSelection=t[0].querySelector("[data-variant-selection]"),this.variantSelection&&(this.variantSelection.addEventListener("variant-change",(t=>this._switchVariant(t.detail.product,t.detail.variant,t.detail.state))),i&&(this.surfacePickUp=new x(i),this.surfacePickUp.onModalRequest((e=>{Promise.all([this.variantSelection.getProduct(),this.variantSelection.getVariant()]).then((([i,n])=>{const r=t[0].querySelector("[data-surface-pick-up-modal]"),o=document.createDocumentFragment(),s=document.createElement("div"),a=document.createElement("span"),l=document.createElement("span");s.classList.add("surface-pick-up__modal-header"),a.classList.add("surface-pick-up__modal-title"),l.classList.add("surface-pick-up__modal-subtitle"),a.innerHTML=i.title,l.innerHTML=n.title,s.appendChild(a),"Default Title"!==n.title&&s.appendChild(l),o.appendChild(s),r.innerHTML=e,r.insertBefore(o,r.firstChild),$.fancybox.open(r,{hash:!1,infobar:!1,toolbar:!1,loop:!0,smallBtn:!0,buttons:[],touch:!1,video:{autoStart:!1},mobile:{preventCaptionOverlap:!1,toolbar:!0},beforeShow:()=>{document.body.style.top=`-${window.scrollY}px`,document.body.style.position="fixed"},beforeClose:()=>{const t=document.body.style.top;document.body.style.position="",document.body.style.top="",window.scrollTo(0,-1*parseInt(t||0,10))}})}))})))),e&&(this.priceUI=new D(e));const r=t.find(".product-gallery__main"),o=t.find(".sticky-product-scroll");r&&(this.enableSlideshow(r),this._data.enable_zoom&&document.addEventListener("lazyloaded",this.enableZoom),this._data.enable_product_lightbox&&this.enableLightbox(r)),n&&(this.complementaryProducts=new b({sectionEl:this._section,sectionId:this._data.section_id,productId:this._data.product.id,productRecommendationsRoute:window.PXUTheme.routes.product_recommendations_url,includeIndicatorDots:!0,limit:this._data.product_recommendation_limit,arrowShape:"M 95.04 46 21.68 46 48.18 22.8 42.91 16.78 4.96 50 42.91 83.22 48.18 77.2 21.68 54 95.04 54 95.04 46z"})),o&&window.isScreenSizeLarge()&&"image-scroll"===this._data.template&&this.enableStickyScroll(o,r),"?contact_posted=true"===window.location.search&&($(".notify_form .contact-form").hide(),$(".notify_form .contact-form").prev(".message").html(window.PXUTheme.translation.notify_form_success)),$(".masonry--true").length>0&&window.PXUTheme.applyMasonry(".thumbnail"),this.variantSelection&&Promise.all([this.variantSelection.getProduct(),this.variantSelection.getVariant(),this.variantSelection.getState()]).then((([t,e,i])=>this._switchVariant(t,e,i)))}enableStickyScroll(t,e){let i=0,n=0;void 0!==window.PXUTheme.jsAnnouncementBar&&window.PXUTheme.jsAnnouncementBar.enable_sticky&&(i=$("#announcement-bar").outerHeight()),"vertical"!==window.PXUTheme.theme_settings.header_layout&&window.PXUTheme.jsHeader.enable_sticky&&(n=$("#header").outerHeight());
// enable if more than 1 image is present
e.data("media-count")>1&&t.stick_in_parent({offset_top:i+n+20})}enableLightbox(t){t.find(".product-gallery__link").fancybox({beforeClose:t=>{const e=t.$trigger.first().parents(".product-gallery__main");e.hide(),setTimeout((()=>e.fadeIn(100)),500)},afterClose:()=>{setTimeout((()=>{t.find(".is-selected a").focus()}),500)}})}enableZoom(){const t=$(event.target),e=t.data("zoom-src");e&&t.wrap('<span class="zoom-container"></span>').css("display","block").parent().zoom({url:e,touch:!1,magnify:1})}disableSlideshow(t,e){let i;i=t?t.find(".flickity-enabled"):$(e),i.flickity("destroy")}enableSlideshow(t,e){
// Define variables
const i=t,n=i.closest(".product-gallery").find(".product-gallery__thumbnails"),r=i.find(".product-gallery__image"),o=n.find(".product-gallery__thumbnail");function checkForVideos(){r.each(((t,e)=>{
// Variables
const i=$(e),n=i.data("media-type")||i.find("[data-media-type]").data("media-type");let r=i.find("video").data("plyr-video-id");const o=i.find("iframe").attr("id");i.hasClass("is-selected")&&("video"===n?(r=i.find("video").data("plyr-video-id"),r&&function autoplayVideo(t,e){
// Compare id to player object and only play that video
$.each(window.videoPlayers,((i,n)=>{n.id===t&&(n.play(),
// On fullscreen toggle, focus back on the slide itself
n.on("exitfullscreen",(()=>e.closest(".product-gallery").find(".product-gallery__thumbnails").focus())))}))}(r,i)):"external_video"===n&&o&&function autoplayYoutubeVideo(t,e){
// compare id to player object and only play that video
$.each(window.videoPlayers,((i,n)=>{n.playing&&n.pause(),n.media.id===t&&(n.play(),
// On fullscreen toggle, focus back on the slide itself
n.on("exitfullscreen",(()=>e.closest(".product-gallery").find(".product-gallery__thumbnails").focus())))}))}(o,i))}))}
// Adds 'product-gallery__image' class if not present
i.find(".gallery-cell:not(.product-gallery__image)").addClass("product-gallery__image"),
// Adds 'product-gallery__thumbnail' class if not present
n.find(".gallery-cell:not(.product-gallery__thumbnail)").addClass("product-gallery__thumbnail");
// If custom settings available, use them otherwise take settings from product templates
const{thumbnails_enabled:s,enable_thumbnail_slider:a,thumbnail_position:l,gallery_arrows:c,slideshow_speed:d,slideshow_transition:h}=e||this._data;i.on("ready.flickity",(()=>{r.each(((t,e)=>{
// Determine media type
const n=$(e).data("media-type")||$(e).find("[data-media-type]").data("media-type");let r;const o=$("[data-video-loop]").data("video-loop"),{videoPlayers:s}=window;switch(n){case"external_video":if(r=$(e).find("[data-plyr-video-id]").data("plyr-video-id"),s)for(let t=0;t<s.length;t++)s[t].id!==r&&s[t].media.id!==r||(s[t].loop=o,$(e).hasClass("is-selected")||(s[t].keyboard={focused:!1,global:!1}));break;case"video":if(r=$(e).find("[data-plyr-video-id]").data("plyr-video-id"),s)for(let t=0;t<s.length;t++)s[t].id!==r&&s[t].media.id!==r||(s[t].loop=o,$(e).hasClass("is-selected")||(s[t].keyboard={focused:!0,global:!1}));break;case"model":$(e).hasClass("is-selected")&&"model"===n&&window.isScreenSizeLarge()&&($(e).on("mouseenter",(()=>i.flickity("unbindDrag"))),$(e).on("mouseleave",(()=>i.flickity("bindDrag"))))}
// Detect keyboard 'ENTER' key on slides
$(e).keypress((t=>{13===t.which&&(
// Bring focus to media inside selected slide
$(e).find("model-viewer, .product-gallery__link, .plyr").focus(),
// Run video autoplay logic if featured media is a video
"video"!==n&&"external_video"!==n||checkForVideos())}))}))})),i.flickity({wrapAround:!0,adaptiveHeight:!0,dragThreshold:10,imagesLoaded:!0,pageDots:!1,prevNextButtons:i.data("media-count")>1||r.length>1,autoPlay:1e3*d,fade:"fade"===h,watchCSS:"image-scroll"===this._data.template&&!i.hasClass("js-gallery-modal"),// Disables Flickity for main product gallery on image-scroll template
arrowShape:window.arrowShape}),i.on("change.flickity",(()=>{r.each(((t,e)=>{
// Determine media type of current slide
const n=$(e).data("media-type")||$(e).find("[data-media-type]").data("media-type");if($(e).hasClass("is-selected"))// When active slide
if("model"===n)
/* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */
window.isScreenSizeLarge()&&(
// On mouseenter event, unbind flickity
$(e).on("mouseenter",(()=>i.flickity("unbindDrag"))),
// On mouseleave event, bind flickity
$(e).on("mouseleave",(()=>i.flickity("bindDrag")))),
// Listen for model pause/play events
$(e).find("model-viewer").on("shopify_model_viewer_ui_toggle_play",(()=>i.flickity("unbindDrag"))),$(e).find("model-viewer").on("shopify_model_viewer_ui_toggle_pause",(()=>i.flickity("bindDrag")));else i.flickity("bindDrag");else
// When inactive slide
switch(n){case"external_video":case"video":
// HTML5 video pausing
$.each(window.videoPlayers,((t,e)=>e.pause()));break;case"model":$.each(window.PXUTheme.productMedia.models,((t,e)=>e.pause()))}})),
// Restore 3d model icons
window.PXUTheme.productMedia.showModelIcon(i)}));
// Checks for videos and plays them if they are the featured media
// Autoplay logic only happens on desktop, autoplay set to off for mobile
const u=i.find(".flickity-prev-next-button");let p;if((u||o)&&window.isScreenSizeLarge()?(u.on("click",(()=>(i.on("settle.flickity",(()=>{
// Find out media type of featured media slide
const t=i.find(".product-gallery__image.is-selected"),e=t.data("media-type")||t.find("[data-media-type]").data("media-type"),n=i.data("product-id");
// Autoplay model if featured media is a model
if(
// Run video autoplay logic if featured media is a video
"video"!==e&&"external_video"!==e||checkForVideos(),"model"===e){
// Sort models to get those in selected slide
const t=[];$.each(window.PXUTheme.productMedia.models,((e,i)=>{$(i.container).closest(".product-gallery__image").data("product-id")===n&&t.push(i)})),
// If model container has class is-selected then play the model
$.each(t,((t,e)=>{$(e.container).parents(".product-gallery__image").hasClass("is-selected")&&e.play()}))}i.off("settle.flickity")})),!1))),o.on("click",(t=>{const e=$(t.currentTarget).index();return i.flickity("select",e),i.on("settle.flickity",(()=>{
// Find out media type of featured media slide
const t=i.find(".product-gallery__image.is-selected"),e=t.data("media-type")||t.find("[data-media-type]").data("media-type"),n=i.data("product-id");
// Autoplay model if featured media is a model
if(
// Run video autoplay logic if featured media is a video
"video"!==e&&"external_video"!==e||checkForVideos(),"model"===e){
// Sort models to get those in selected slide
const t=[];$.each(window.PXUTheme.productMedia.models,((e,i)=>{$(i.container).closest(".product-gallery__image").data("product-id")===n&&t.push(i)})),
// If model container has class is-selected then play the model
$.each(t,((t,e)=>{$(e.container).parents(".product-gallery__image").hasClass("is-selected")&&e.play()}))}i.off("settle.flickity")})),!1})),o.keypress((t=>{const e=$(t.currentTarget).index();if(13===t.which){i.flickity("select",e);const t=i.find(".product-gallery__image.is-selected"),n=i.data("product-id");i.on("settle.flickity",(()=>{t.find("model-viewer, .plyr, a").focus(),t.find("[data-youtube-video]").attr("tabindex","0"),i.off("settle.flickity")}));
// Find out media type of featured media slide
const r=t.data("media-type");
// Run video autoplay logic if featured media is a video
// Autoplay model if featured media is a model
if("video"!==r&&"external_video"!==r||checkForVideos(),"model"===r){
// Sort models to get those in selected slide
const t=[];$.each(window.PXUTheme.productMedia.models,((e,i)=>{$(i.container).closest(".product-gallery__image").data("product-id")===n&&t.push(i)})),
// If model container has class is-selected then play the model
$.each(t,((t,e)=>{$(e.container).parents(".product-gallery__image").hasClass("is-selected")&&e.play()}))}}}))):s&&
// If thumbnail slider is disabled, ensure thumbnails can still navigate product images
n.find(".product-gallery__thumbnail").on("click",(t=>{const e=$(t.currentTarget).index();i.flickity("selectCell",e)})),
// Resize flickity when the slider is settled
i.on("settle.flickity",(()=>i.flickity("resize"))),$(window).on("load",(()=>i.flickity("resize"))),$(window).on("resize",(()=>{clearTimeout(p),p=setTimeout((()=>i.flickity("resize")),250)})),!0===s&&!0===a&&r.length>1)
// If desktop determine which slider we build
if(window.isScreenSizeLarge())if("right-thumbnails"===l||"left-thumbnails"===l){n.addClass("vertical-slider-enabled");const t=o.height(),e=n.height();
// Resize thumbnail gallery
$(window).on("load",(()=>{const t=i.height();n.css("max-height",t)})),$(window).on("resize",(()=>{i.flickity("resize");const t=i.height();n.css("max-height",t)})),i.on("change.flickity",(()=>{i.flickity("resize");const t=i.height();n.css("max-height",t)})),i.on("select.flickity",(()=>{
// set selected nav cell
const r=i.data("flickity");if(r){n.find(".is-nav-selected").removeClass("is-nav-selected");const i=o.eq(r.selectedIndex).addClass("is-nav-selected").position().top+n.scrollTop()-(e+t)/2;
// scroll nav
n.animate({scrollTop:i})}}))}else n.flickity({cellAlign:"center",contain:!0,groupCells:"80%",imagesLoaded:!0,pageDots:!1,prevNextButtons:o.length>5&&c,asNavFor:"image-scroll"===this._data.template&&window.isScreenSizeLarge()?"":i[0],arrowShape:window.arrowShape}),
// Resize flickity when the slider is settled
n.on("settle.flickity",(()=>n.flickity("resize"))),$(window).on("load",(()=>n.flickity("resize")));else
// Otherwise create standard thumbnail slider
n.flickity({cellAlign:"center",contain:!0,groupCells:"80%",imagesLoaded:!0,pageDots:!1,prevNextButtons:o.length>5,asNavFor:"image-scroll"===this._data.template&&window.isScreenSizeLarge()?"":i[0],arrowShape:window.arrowShape})}findSelectedVariantImage(){$("[data-variant-selector]").on("selectedVariantChanged",(t=>{const e=$(t.currentTarget);e.attr("disabled")||function getIndex(t,e){const i=t.parents(".product_form").find(`select option[value=${e}]`).attr("data-image-id");if(!i)
// If there is no image, no scrolling occurs
return!1;const n=$(`[data-image-id=${i}]`).data("index");return"image-scroll"===this._data.template&&(this.scrollSelectedImage(n),!0)}(e,e.val())}))}scrollSelectedImage(t){let e=0,i=0;
// Get header height is sticky enabled
!0===window.PXUTheme.jsHeader.enable_sticky&&"vertical"!==window.PXUTheme.theme_settings.header_layout&&(e=window.PXUTheme.jsHeader.getHeaderHeight()),
// Get announcement height is sticky enabled
void 0!==window.PXUTheme.jsAnnouncementBar&&!0===window.PXUTheme.jsAnnouncementBar.enable_sticky&&"vertical"!==window.PXUTheme.theme_settings.header_layout&&(i=window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight());
// Add values
const n=e+i;window.PXUTheme.scrollToTop($(`[data-index="${t}"]`),n)}unload(t){$(".selector-wrapper select",t).unwrap(),this.disableSlideshow(t),$("[data-variant-selector]").off(),document.removeEventListener("lazyloaded",this.enableZoom)}_switchVariant(t,e,i){if(window.selectCallback(this._section.querySelector(`.product-${t.id}`),t,e,i),this.priceUI){const formatter=t=>0===t?window.PXUTheme.translation.free_price_text:Shopify.formatMoney(t,$("body").data("money-format"));this.priceUI.load(t,{variant:e,formatter:formatter,handler:(t,n,{variant:r})=>{if("unavailable"===i)return document.createDocumentFragment();if(r&&r.available){const i=this._section.querySelector("[data-shop-pay-installments-template] shopify-payment-terms");let n=null;if(i&&(n=i.cloneNode(!0),n.setAttribute("variant-id",e.id)),this._data.display_savings&&r.compare_at_price>r.price){const e=document.createElement("span");e.classList.add("sale","savings"),e.innerHTML=`${window.PXUTheme.translation.product_savings} <span class="percentage">${Math.round(parseFloat(100*(r.compare_at_price-r.price)/r.compare_at_price,10))}%</span> <span class="percentage">(</span><span class="money">${formatter(r.compare_at_price-r.price)}</span><span class="percentage">)</span>`,t.appendChild(e)}n&&t.appendChild(n)}
// Convert all elements if currency converter is enabled
if(window.PXUTheme.currencyConverter){const e=t.querySelectorAll(".money");for(let t=0;t<e.length;t++)window.PXUTheme.currencyConverter.update(e[t])}return t}})}if(this.surfacePickUp&&this.surfacePickUp.load(e?e.id:null),this._section.classList.contains("product-template")){const i=`${t.handle}?${$.param({variant:e.id})}`;history.replaceState({},"variant",i)}}}window.PXUTheme.jsProductClass=Product,window.PXUTheme.jsProduct={init:t=>new Product(t),relatedProducts(){$(".js-related-products-slider .products-slider").each(((t,e)=>{const i=$(e),n={products_per_slide:i.data("products-per-slide"),products_available:i.data("products-available"),products_limit:i.data("products-limit"),initialIndex:0,cellAlign:"left",wrapAround:!0};n.products_available>n.products_per_slide&&n.products_limit>n.products_per_slide?n.wrapAround=!0:n.wrapAround=!1,n.products_available<n.products_per_slide||n.products_limit<n.products_per_slide?(i.addClass("container is-justify-center"),i.find(".gallery-cell").addClass("column")):(i.flickity({lazyLoad:2,freeScroll:!0,imagesLoaded:!0,draggable:!0,cellAlign:"center",wrapAround:n.wrapAround,pageDots:!1,contain:!0,prevNextButtons:n.products_limit>n.products_per_slide,initialIndex:n.initialIndex,arrowShape:window.arrowShape}),
// Resize flickity when the slider is settled
i.on("settle.flickity",(()=>i.flickity("resize"))),$(window).on("load",(()=>i.flickity("resize"))))}))}}})
/******/();